import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Col, Form, Modal, Row, Nav, Tab } from "react-bootstrap";
import { post, postFormData } from "../../../helpers/api_helper";

import { SVGICON } from "../../../constant/theme";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomInput from "../../../CustomControls/CustomInput";
import { useFormikContext } from "formik";
import moment from "moment";
import {
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetCustomerContactPersonDDL,
  POST_GetDepartmentDropDownList,
  POST_GetTestingUTDetailByID,
  POST_TestingsNDTFilesSave,
  POST_TestingsUTSave,
} from "../../../helpers/url_helper";
import {
  customConfirmDialog,
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";

const NDTProcessTypeUT = ({
  InwardMaterialIDEncrypted,
  InwardMaterialTestDetailID,
  MainFormik,
}) => {
  //const { values, setFieldValue } = useFormikContext();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [showAddTPIDetailModal, setShowAddTPIDetailModal] = useState(false);
  const [tpiContactPersonOptions, setTPIContactPersonOptions] = useState([]);
  const [showTestMasterImagesModal, setShowTestMasterImagesModal] =
    useState(false);
  const [showTestingImagesModal, setShowTestingImagesModal] = useState(false);

  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [showTestingRemarksModal, setShowTestingRemarksModal] = useState(false);
  const [testMethodOptions, setTestMethodOptions] = useState([]);

  const [machineOptions, setMachineOptions] = useState([]);
  const [uploadUTFilePath, setUploadUTFilePath] = useState(null);

  const additionsToDeviationsOptions = [
    { label: "Not Applicable", value: 1 },
    { label: "Applicable", value: 2 },
  ];

  const radiationEnergyOptions = [
    { label: "X-rays", value: 1 },
    { label: "Gamma rays", value: 2 },
  ];

  const ListOfForms = [
    { label: "Detail", FormNo: 1 },
    { label: "Equipment", FormNo: 2 },
    { label: "Prob", FormNo: 3 },
  ];

  let initialListOfTestingUTDetail = {
    TestingUTDetailIDEncrypt: "",
    TestingUTIDEncrypt: "",
    ChallanNo: "",
    ChallanDate: "",
    OfferNo: "",
    OfferDate: "",
    JobDescripation: "",
    UTNo: "",
    HeatNo: "",
    JointNo: "",
    Quantity: "",
    Observation: "",
    Result: "",
    IsDelete: false,
  };

  let initialListOfTestingUTEquipmentDetail = {
    TestingUTEquipmentDetailIDEncrypt: "",
    TestingUTIDEncrypt: "",
    EquipmentIDEncrypt: "",
    Make: "",
    SerialNo: "",
    CalibrationDueDate: "",
    Type: "",
    IsDelete: false,
  };

  let initialListOfTestingUTProbDetail = {
    TestingUTProbDetailIDEncrypt: "",
    TestingUTIDEncrypt: "",
    TypeOfProbe: "",
    SizeOfProbe: "",
    RefractionAngle: "",
    Frequency: "",
    SerialNo: "",
    Remark: "",
    RefGain: "",
    ScanningGain: "",
    CalibrationRange: "",
    IsDelete: false,
  };

  useEffect(() => {
    //Reset Details
    formik.setFieldValue("AllowTestingEdit", 0);
    formik.setFieldValue("TestMasterIDEncrypt", "");
    formik.setFieldValue("TestingIDEncrypt", "");
    formik.setFieldValue("InwardIDEncrypt", "");
    formik.setFieldValue("CustomerProjectIDEncrypted", "");
    formik.setFieldValue("InwardNo", "");
    formik.setFieldValue("InwardDate", "");
    formik.setFieldValue("ExpectedDateOfDelivery", "");
    formik.setFieldValue("IsMaterialReturnable", false);
    formik.setFieldValue("IsTPIRequired", false);
    formik.setFieldValue("LetterRefNo", "");
    formik.setFieldValue("ListOfLetterRefDoc", []);
    formik.setFieldValue("TCNo", "");
    formik.setFieldValue("DepartmentIDEncrypt", "");
    formik.setFieldValue("DepartmentName", "");
    formik.setFieldValue("ProductGroupIDEncrypt", "");
    formik.setFieldValue("ProductGroupName", "");
    formik.setFieldValue("MaterialTypeIDEncrypt", "");
    formik.setFieldValue("MaterialTypeName", "");
    formik.setFieldValue("SampleNote", "");
    formik.setFieldValue("TestingDate", new Date());
    formik.setFieldValue("TestingToDate", new Date());
    formik.setFieldValue("TestingQty", "");
    formik.setFieldValue("InvoiceQty", "");
    formik.setFieldValue("UnitID", "");
    formik.setFieldValue("TestMethodIDEncrypt", "");
    formik.setFieldValue("ReferenceStandardIDEncrypted", "");
    formik.setFieldValue("MachineIDEncrypt", "");
    formik.setFieldValue("Size", "");
    formik.setFieldValue("Condition", "");
    formik.setFieldValue("SampleDetail", "");
    formik.setFieldValue("LocationType", 1);
    setTestMethodOptions([]);
    setMachineOptions([]);
    //setReferenceStandardOptions([]);

    formik.setFieldValue("ListTestingBy", []);
    formik.setFieldValue("ListOfTPIDetails", []);
    formik.setFieldValue("ListTestMasterImages", []);
    formik.setFieldValue("ListTestingResultImages", []);
    formik.setFieldValue("Result", "");
    formik.setFieldValue("Remarks", "");
    formik.setFieldValue("ChangeNote", "");
    formik.setFieldValue("TestingStatus", "");
    formik.setFieldValue("ReferenceSubGroup", "");
    formik.setFieldValue("ParameterWith", 1);
    formik.setFieldValue("IsMergeSameValue", false);

    formik.setFieldValue("BasedOnMeasurementValue", "");
    formik.setFieldValue("BasedOnHrsValue", "");
    formik.setFieldValue("ListOfTestDefineMoreRates", []);
    formikDefineMoreRates.setFieldValue("MoreTestRatesList", []);

    formik.setFieldValue("Location", "");
    formik.setFieldValue("DieNo", "");
    formik.setFieldValue("HeatNo", "");
    formik.setFieldValue("DRGNo", "");
    formik.setFieldValue("Thikness", "");
    formik.setFieldValue("AreatoBeCovered", "");
    formik.setFieldValue("RadiationEnergy", "");
    formik.setFieldValue("Density", "");
    formik.setFieldValue("Sensitivity", "");
    formik.setFieldValue("AcceptanceStandardEncrypted", "");
    formik.setFieldValue("AcceptanceStandardName", "");

    formik.setFieldValue("AdditionsToDeviations", 0);
    formik.setFieldValue("JobType", "");
    formik.setFieldValue("JobDescripation", "");
    formik.setFieldValue("JobDescripationLabel", "");
    formik.setFieldValue("ProcedureID", 0);
    formik.setFieldValue("SurfaceCondition", "");
    formik.setFieldValue("ExtentOfExa", "");
    formik.setFieldValue("StageOfExa", "");
    formik.setFieldValue("SurfaceTemp", "");
    formik.setFieldValue("Couplant", "");

    formik.setFieldValue("Method", "");
    formik.setFieldValue("WeldingProcess", "");
    formik.setFieldValue("BasicCaliBlock", "");
    formik.setFieldValue("RefSensitivity", "");
    formik.setFieldValue("WorksheetNo", "");
    formik.setFieldValue("TestCarriedOutat", "");
    formik.setFieldValue("UTNoLabel", "");
    formik.setFieldValue("HeatNoLabel", "");
    formik.setFieldValue("QtyLabel", "");
    formik.setFieldValue("JointNoLabel", "");

    formik.setFieldValue("UploadFilePath", "");
    formik.setFieldValue("UploadFilePathURL", "");
    formik.setFieldValue("UploadFilePathFileKey", "");
    setUploadUTFilePath(null);
    formik.setFieldValue("acceptanceStandardOptions", []);
    formik.setFieldValue("materialTypeOptions", []);
    formik.setFieldValue("productGroupOptions", []);
    formik.setFieldValue("referenceStandardOptions", []);
    formik.setFieldValue("ListOfTestingUTDetail", [
      initialListOfTestingUTDetail,
    ]);
    formik.setFieldValue("ListOfTestingUTEquipmentDetail", [
      initialListOfTestingUTEquipmentDetail,
    ]);
    formik.setFieldValue("ListOfTestingUTProbDetail", [
      initialListOfTestingUTProbDetail,
    ]);

    getTestingRemarksList();
    if (InwardMaterialTestDetailID) {
      getTestingUTDetailByID(InwardMaterialTestDetailID);
    }
  }, [InwardMaterialTestDetailID]);

  const validationSchema = Yup.object().shape({
    InwardMaterialTestDetailIDEncrypt: Yup.string().required(
      "Test Name is required field"
    ),
    AcceptanceStandardEncrypted: Yup.string().required(
      "Acceptance Standard is required field"
    ),

    ProductGroupIDEncrypt: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Material Group is required field");
        return schema;
      }
    ),
    MaterialTypeIDEncrypt: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Material Type is required field");
        return schema;
      }
    ),
    ChangeNote: Yup.string().when(
      ["btnSubmitType", "TestingStatus"],
      ([btnSubmitType, TestingStatus], schema) => {
        if (btnSubmitType != 1 && TestingStatus > 1)
          return Yup.string().required("Change Note is required field");
        return schema;
      }
    ),

    SampleDetail: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string()
            .trim()
            .required("Sample Detail is required field");
        return schema;
      }
    ),
    Condition: Yup.string().when("btnSubmitType", ([btnSubmitType], schema) => {
      if (btnSubmitType != 1)
        return Yup.string().trim().required("Condition is required field");
      return schema;
    }),
    Size: Yup.string().when("btnSubmitType", ([btnSubmitType], schema) => {
      if (btnSubmitType != 1)
        return Yup.string().trim().required("Size is required field");
      return schema;
    }),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      TestMasterIDEncrypt: "",
      InwardMaterialIDEncrypt: MainFormik?.InwardMaterialIDEncrypt,
      TestingIDEncrypt: "",
      InwardIDEncrypt: "",
      InwardMaterialTestDetailIDEncrypt: InwardMaterialTestDetailID,
      InwardNo: "",
      InwardDate: "",
      ExpectedDateOfDelivery: "",
      InwardMaterialID: "",
      TestName: "",
      TestingDate: new Date(),
      TestingToDate: new Date(),
      TestingQty: "",
      InvoiceQty: "",
      UnitID: "",
      TestMethodIDEncrypt: "",
      TestingByID: "",
      ReferenceStandardIDEncrypted: "",
      MachineIDEncrypt: "",
      ParameterWith: 1,
      IsMergeSameValue: false,
      ReferenceSubGroup: "",
      Result: "",
      Remarks: "",
      ChangeNote: "",
      TestingStatus: 0,
      LetterRefNo: "",
      SampleNote: "",
      IsMaterialReturnable: false,
      IsTPIRequired: true,
      ListOfLetterRefDoc: [],
      ListOfTPIDetails: [],
      ListTestingResultImages: [],
      ListTestMasterImages: [],
      TCNo: "",
      DepartmentIDEncrypt: "",
      DepartmentName: "",
      ProductGroupIDEncrypt: "",
      ProductGroupName: "",
      MaterialTypeName: "",
      MaterialTypeIDEncrypt: "",
      SampleDetail: "",
      searchTestingBy: "",
      ListTestingBy: [],
      Condition: "",
      Size: "",
      CustomerProjectIDEncrypted: "",
      btnSubmitType: 1,
      IsNABLRangeChange: false,
      IsReTestTesting: false,
      TestName: "",
      TestingDateDisplay: "",
      TestingToDateDisplay: "",
      MachineName: "",
      UnitName: "",
      TestMethodName: "",
      ReferenceStandardName: "",
      AllowTestingEdit: 0,
      IsDefaultLoad: false,
      LocationType: 0,
      IsDefaultLoadCalculateAverage: false,
      ListOfTestDefineMoreRates: [],
      BasedOnMeasurementValue: "",
      BasedOnHrsValue: "",
      IsNDT: false,
      Location: "",
      DieNo: "",
      HeatNo: "",
      DRGNo: "",
      Thikness: "",
      AreatoBeCovered: "",
      RadiationEnergy: "",
      Density: "",
      Sensitivity: "",
      TestType: 1,
      NDTProcessType: 0,
      AcceptanceStandardName: "",
      AcceptanceStandardEncrypted: "",
      TestingUTIDEncrypt: "",
      AdditionsToDeviations: 0,
      JobType: "",
      JobDescripation: "",
      ProcedureID: 0,
      SurfaceCondition: "",
      ExtentOfExa: "",
      StageOfExa: "",
      SurfaceTemp: "",
      Couplant: "",
      Method: "",
      WeldingProcess: "",
      BasicCaliBlock: "",
      RefSensitivity: "",
      TestCarriedOutat: "",
      WorksheetNo: "",
      UploadFilePath: "",
      UploadFilePathURL: "",
      UploadFilePathFileKey: "",
      JobDescripationLabel: "Job Descripation",
      UTNoLabel: "Tested Area",
      HeatNoLabel: "Size(mm)",
      QtyLabel: "Quantity",
      JointNoLabel: "I.D. No",
      ListOfTestingUTDetail: [initialListOfTestingUTDetail],
      ListOfTestingUTEquipmentDetail: [initialListOfTestingUTEquipmentDetail],
      ListOfTestingUTProbDetail: [initialListOfTestingUTProbDetail],
      acceptanceStandardOptions: [],
      materialTypeOptions: [],
      productGroupOptions: [],
      referenceStandardOptions: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InwardMaterialIDEncrypt,
      TestMasterIDEncrypt,
      InwardMaterialTestDetailIDEncrypt,
      InwardNo,
      InwardDate,
      ReferenceStandardIDEncrypted,
      ExpectedDateOfDelivery,
      LetterRefNo,
      SampleNote,
      IsMaterialReturnable,
      IsTPIRequired,
      ListOfLetterRefDoc,
      ListOfTPIDetails,
      TCNo,
      DepartmentName,
      TestingStatus,
      IsReTestTesting,
      TestingDate,
      TestingToDate,
      AllowTestingEdit,
      ListOfTestDefineMoreRates,
      BasedOnMeasurementValue,
      BasedOnHrsValue,
      IsNDT,
      Location,
      NDTProcessType,
      ListOfTestingUTDetail,
      ListOfTestingUTEquipmentDetail,
      ListOfTestingUTProbDetail,
      acceptanceStandardOptions,
      materialTypeOptions,
      productGroupOptions,
      referenceStandardOptions,
      searchTestingBy,
      ListTestingBy,
      ListTestingResultImages,
      ListTestMasterImages,
      UploadFilePath,
      UploadFilePathURL,
      UploadFilePathFileKey,
      UTNoLabel,
      HeatNoLabel,
      QtyLabel,
      JointNoLabel,
      JobDescripationLabel,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    //alert(1);

    if (values?.ListOfTestingUTDetail) {
      const challanNumbers = values?.ListOfTestingUTDetail.map(
        (e) => e.ChallanNo
      ).filter((x) => x); // remove empty/null
      const hasDuplicate =
        new Set(challanNumbers).size !== challanNumbers.length;

      if (hasDuplicate) {
        warningMessage("Challan No already exists (duplicate found)");
        return;
      }
    }

    if (values?.ListOfTestingUTProbDetail) {
      const typeOfProbe = values?.ListOfTestingUTProbDetail.map((e) =>
        e.TypeOfProbe.trim().toLowerCase()
      ).filter((x) => x); // remove empty/null
      const hasDuplicate = new Set(typeOfProbe).size !== typeOfProbe.length;

      if (hasDuplicate) {
        warningMessage("Type Of Probe already exists (Prob duplicate found)");
        return;
      }
    }

    if (
      values.btnSubmitType != 1 &&
      ReferenceStandardIDEncrypted &&
      referenceStandardOptions?.filter(
        (x) => x?.value == ReferenceStandardIDEncrypted
      )[0]?.IsExpiredReferenceStandard == true
    ) {
      warningMessage("Reference Standard is Expired..!");
      return;
    }
    if (
      ListTestingBy?.filter((e) => e.IsSelected == true)?.length == 0 &&
      values.btnSubmitType != 1
    ) {
      //warningMessage("Please select atleast one Testing By...");
      formik.setFieldError("ListTestingBy", "Testing By is required field");
      formik.setFieldTouched("ListTestingBy", true);
      return;
    }

    if (AuthUser?.Permissions?.Account == 1 && values?.btnSubmitType != 1) {
      if (
        ListOfTestDefineMoreRates?.filter(
          (e) => e?.IsSelected == true && e?.RateType == 4 //Based On Measurement
        )?.length > 0
      ) {
        if (values?.UnitID == "") {
          formik.setFieldError("UnitID", "Please select Unit...");
          formik.setFieldTouched("UnitID", true);
          return;
        }

        if (values?.BasedOnMeasurementValue == "") {
          formik.setFieldError(
            "BasedOnMeasurementValue",
            "Based On Measurement Value is required field..."
          );
          formik.setFieldTouched("BasedOnMeasurementValue", true);
          return;
        }
      }

      if (
        ListOfTestDefineMoreRates?.filter(
          (e) => e?.IsSelected == true && e?.RateType == 7 //Based On Hrs
        )?.length > 0 &&
        values?.BasedOnHrsValue == ""
      ) {
        formik.setFieldError(
          "BasedOnHrsValue",
          "Based On HrsValue is required field..."
        );
        formik.setFieldTouched("BasedOnHrsValue", true);
        return;
      }
    }

    let payload = {
      ...values,
      BasedOnMeasurementValue: values?.BasedOnMeasurementValue
        ? values?.BasedOnMeasurementValue.toString()
        : "",
      BasedOnHrsValue: values?.BasedOnHrsValue
        ? values?.BasedOnHrsValue.toString()
        : "",
      ReferenceStandardIDEncrypt: values?.ReferenceStandardIDEncrypted,
      TestingDate: values?.TestingDate
        ? moment(values?.TestingDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      TestingToDate: values?.TestingToDate
        ? moment(values?.TestingToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      InwardDate: values?.InwardDate
        ? moment(new Date(values?.InwardDate))
            .format("YYYY-MM-DD")
            .replace(/^\-/, "")
        : "",

      TestingStatus:
        values?.btnSubmitType == 1 ? 2 : values?.btnSubmitType == 3 ? 4 : 3,
      Conditione: values?.Condition,
      TestingByIDs: Array.from(
        ListTestingBy?.filter((e) => e.IsSelected == true),
        (x) => x.EmployeeIDEncrypt
      ).join(","),
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      ListOfTestDefineMoreRates: ListOfTestDefineMoreRates?.filter(
        (e) => e?.IsSelected == true
      ),
      ListOfTPIDetails: values?.ListOfTPIDetails?.map((x, i) => {
        return {
          ...x,
          InwardTPIDetailIDEncrypted: x.TestingTPIIDEncrypt,
          TPIExpectedDate: x.TPIExpectedDate
            ? moment(x.TPIExpectedDate).format("YYYY-MM-DD").replace(/^\-/, "")
            : "",
        };
      }),

      ListOfTestingUTDetail: values?.ListOfTestingUTDetail?.map((x, i) => {
        return {
          ...x,
          ChallanDate: x.ChallanDate
            ? moment(x.ChallanDate).format("YYYY-MM-DD").replace(/^\-/, "")
            : "",
          OfferDate: x.OfferDate
            ? moment(x.OfferDate).format("YYYY-MM-DD").replace(/^\-/, "")
            : "",
          Quantity: x?.Quantity ? x.Quantity : 0,
        };
      }),

      ListOfTestingUTEquipmentDetail:
        values?.ListOfTestingUTEquipmentDetail?.map((x, i) => {
          return {
            ...x,
            CalibrationDueDate: x.CalibrationDueDate
              ? moment(x.CalibrationDueDate)
                  .format("YYYY-MM-DD")
                  .replace(/^\-/, "")
              : "",
          };
        }),

      ListOfTestingUTProbDetail: values.ListOfTestingUTProbDetail,
    };

    console.log("payload", payload);

    post(POST_TestingsUTSave, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          if (
            MainFormik?.ListOfLetterRefDoc?.length > 0 ||
            values?.ListTestingResultImages?.length > 0 ||
            uploadUTFilePath != null
          ) {
            let formData = new FormData();
            formData.append("InwardIDEncrypt", values?.InwardIDEncrypt);
            formData.append("TestingIDEncrypt", values?.TestingIDEncrypt);
            formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
            formData.append(
              "InwardMaterialTestDetailIDEncrypt",
              InwardMaterialTestDetailIDEncrypt
            );
            formData.append("UploadFilePath", uploadUTFilePath);
            formData.append("UploadFilePathURL", UploadFilePathURL);
            formData.append("NDTProcessType", MainFormik?.NDTProcessType);
            formData.append(
              "InwardDate",
              values?.InwardDate
                ? moment(new Date(values?.InwardDate))
                    .format("YYYY-MM-DD")
                    .replace(/^\-/, "")
                : ""
            );
            formData.append(
              "TestingDate",
              values?.TestingDate
                ? moment(values?.TestingDate)
                    .format("YYYY-MM-DD")
                    .replace(/^\-/, "")
                : ""
            );

            //ListOfLetterRefDoc
            Promise.all(
              MainFormik?.ListOfLetterRefDoc?.map((x, i) => {
                formData.append(
                  `ListOfLetterRefDoc[${i}].InwardLetterRefImageIDEncrypted`,
                  x.InwardLetterRefImageIDEncrypted
                );
                formData.append(
                  `ListOfLetterRefDoc[${i}].LetterRefImageFile`,
                  x.LetterRefImageFile
                );
                formData.append(
                  `ListOfLetterRefDoc[${i}].LetterRefImageFilePath`,
                  x.LetterRefImageFilePath
                );
                formData.append(
                  `ListOfLetterRefDoc[${i}].IsDeleted`,
                  x.IsDeleted
                );
              })
            );

            //ListOfTestResultImages
            Promise.all(
              values?.ListTestingResultImages?.map((x, i) => {
                formData.append(
                  `ListOfTestResultImages[${i}].TestingResultImageIDEncrypted`,
                  x.TestingResultImageIDEncrypted
                );
                formData.append(
                  `ListOfTestResultImages[${i}].ResultImageFile`,
                  x.TestingResultImageFile
                );
                formData.append(
                  `ListOfTestResultImages[${i}].ResultImagePath`,
                  x.ResultImagePath
                );
                formData.append(
                  `ListOfTestResultImages[${i}].IsDeleted`,
                  x.IsDeleted
                );
                formData.append(
                  `ListOfTestResultImages[${i}].Remarks`,
                  x.Remarks
                );
              })
            );

            postFormData(POST_TestingsNDTFilesSave, formData)
              .then((res) => {
                if (res?.IsSuccess) {
                  successMessage(response?.Message); //show success message from main api response
                  if (
                    AuthUser?.Permissions?.TestingAfterSaveStayOnEntryScreen ==
                    true
                  ) {
                    setTimeout(() => {
                      //navigate(`/testing/${InwardMaterialIDParam}`);
                      window.location = `/testing-ndt/${window.btoa(
                        InwardMaterialIDEncrypt
                      )}`;
                    }, 800);
                  } else {
                    setTimeout(() => {
                      navigate(-1);
                    }, 1000);
                  }
                } else {
                  errorMessage(res?.Message);
                  setIsLoading(false);
                }
              })
              .catch((error) => {
                console.log(error);
                setIsLoading(false);
              });
          } else {
            successMessage(response?.Message);
            if (
              AuthUser?.Permissions?.TestingAfterSaveStayOnEntryScreen == true
            ) {
              setTimeout(() => {
                // navigate(`/testing/${InwardMaterialIDParam}`);
                window.location = `/testing-ndt/${window.btoa(
                  InwardMaterialIDEncrypt
                )}`;
              }, 800);
            } else {
              setTimeout(() => {
                navigate(-1);
              }, 1000);
            }
          }
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTestingRemarksList = async () => {
    setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 9, //Testing Remarks
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikTestingRemarks.setFieldValue(
            "TestingRemarksList",
            response?.List?.map((item) => ({
              TestingRemarks: item.CategoryName,
              CategoryID: item.CategoryID,
              IsSelected: false,
            }))
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getDepartmentDDLForScopeValidityCheck = async (testingDate) => {
    // setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TransactionDate: testingDate
        ? moment(testingDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : moment(new Date()).format("YYYY-MM-DD").replace(/^\-/, ""),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item?.DepartmentName,
              value: item?.DepartmentIDEncrypted,
              IsNABLScopeExpired: item?.IsNABLScopeExpired,
            }))
          );

          if (MainFormik?.DepartmentIDEncrypt) {
            response?.List?.map((item) => {
              if (
                item?.DepartmentIDEncrypted == MainFormik?.DepartmentIDEncrypt
              ) {
                if (item?.IsNABLScopeExpired == true) {
                  customConfirmDialog(
                    `${item?.DepartmentName} Scope is Expired`,
                    `Do you want to continue?`,
                    () => {
                      if (
                        AuthUser?.Permissions
                          ?.TestingAfterSaveStayOnEntryScreen == true
                      ) {
                        navigate("/testing-list");
                      } else {
                        navigate(-1);
                      }
                    },
                    false
                  );
                }
              }
            });
          }
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const deleteTPI = (i) => {
    if (ListOfTPIDetails[i]?.InwardTPIDetailIDEncrypted) {
      formik.setFieldValue(`ListOfTPIDetails[${i}].IsDeleted`, true);
    } else {
      formik.setFieldValue(
        "ListOfTPIDetails",
        ListOfTPIDetails?.filter((x, ix) => ix != i)
      );
    }
  };

  const addNewTPI = () => {
    formikTPIDetail.resetForm();
    setShowAddTPIDetailModal(true);
  };

  const validationSchemaTPIDetail = Yup.object().shape({
    TPIIDEncrypted: Yup.string().required("TPI is required field"),
    TPIContactPersonIDEncrypted: Yup.string().required(
      "TPI Contact Person is required field"
    ),
  });

  const formikTPIDetail = useFormik({
    validationSchema: validationSchemaTPIDetail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTPIDetail(values, formikHelpers),
    initialValues: {
      TPIIDEncrypted: "",
      TPIContactPersonIDEncrypted: "",
      TPIExpectedDate: "",
      TPIName: "",
      TPIContactPersonName: "",
      displayTPIExpectedDate: "",
      editIndexTPI: "",
      actionFlagTPI: 0, // 0 = Add,  1 = edit
      IsDeleted: false,
    },
    validateOnBlur: false,
  });

  const {
    values: { TPIIDEncrypted, actionFlagTPI },
  } = formikTPIDetail;

  useEffect(() => {
    if (TPIIDEncrypted) {
      formikTPIDetail.setFieldValue("TPIContactPersonIDEncrypted", "");
      getTPIContactPersonDDL();
    } else {
      setTPIContactPersonOptions([]);
      formikTPIDetail.setFieldValue("TPIContactPersonIDEncrypted", "");
    }
  }, [TPIIDEncrypted]);

  const handleValidSubmitTPIDetail = (val) => {
    if (val?.editIndexTPI !== "") {
      if (
        ListOfTPIDetails?.filter(
          (x, i) =>
            x?.TPIIDEncrypted == val?.TPIIDEncrypted &&
            x?.TPIContactPersonIDEncrypted ==
              val?.TPIContactPersonIDEncrypted &&
            x?.IsDeleted == false &&
            i != val?.editIndexTPI
        )?.length > 0
      ) {
        warningMessage("TPI detail already exists!");
        return;
      } else {
        formik.setFieldValue(
          "ListOfTPIDetails",
          ListOfTPIDetails?.map((x, idx) => {
            if (idx == val?.editIndexTPI) {
              return {
                ...x,
                TPIIDEncrypted: val?.TPIIDEncrypted,
                TPIContactPersonIDEncrypted: val?.TPIContactPersonIDEncrypted,
                TPIExpectedDate: val?.TPIExpectedDate,
                TPIName: val?.TPIName,
                TPIContactPersonName: val?.TPIContactPersonName,
                displayTPIExpectedDate: val?.TPIExpectedDate
                  ? moment(val?.TPIExpectedDate).format("DD-MMM-yyyy")
                  : "",
              };
            } else {
              return { ...x };
            }
          })
        );
      }
    } else {
      if (
        ListOfTPIDetails?.filter(
          (x) =>
            x?.TPIIDEncrypted == val?.TPIIDEncrypted &&
            x?.TPIContactPersonIDEncrypted ==
              val?.TPIContactPersonIDEncrypted &&
            x?.IsDeleted == false
        )?.length > 0
      ) {
        warningMessage("TPI detail already exists!");
        return;
      } else {
        formik.setFieldValue("ListOfTPIDetails", [
          ...ListOfTPIDetails,
          {
            ...val,
            displayTPIExpectedDate: val?.TPIExpectedDate
              ? moment(val?.TPIExpectedDate).format("DD-MMM-yyyy")
              : "",
          },
        ]);
      }
    }
    setShowAddTPIDetailModal(false);
  };

  const getTPIContactPersonDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: TPIIDEncrypted,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTPIContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadTestingResultImage = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /image-*/;
      if (!file.type.match(pattern)) {
        warningMessage("Select valid image file!");
      } else {
        formik.setFieldValue("ListTestingResultImages", [
          ...ListTestingResultImages,
          {
            TestingResultImageIDEncrypted: "",
            TestingID: "",
            TestingResultImageFile: file,
            viewFile: URL.createObjectURL(file),
            TestingResultImageFileName: file?.name,
            ResultImagePath: "",
            IsDeleted: false,
            Remarks: "",
          },
        ]);
      }
    }
  };

  const deleteTestingResultImage = (i) => {
    formik.setFieldValue(
      "ListTestingResultImages",
      ListTestingResultImages?.map((x, idx) => {
        if (idx == i) {
          return {
            ...x,
            IsDeleted: true,
          };
        } else {
          return { ...x };
        }
      })
    );
  };

  const validationSchemaTestingImages = Yup.object().shape({});

  const formikTestingImages = useFormik({
    validationSchema: validationSchemaTestingImages,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestingImages(values, formikHelpers),
    initialValues: {
      IsDeleted: false,
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikTestingImages;

  const handleValidSubmitTestingImages = (val) => {};

  const handleChangeSearchTestingBy = (e) => {
    formik.setFieldValue("searchTestingBy", e?.target?.value);
    formik.setFieldValue(
      "ListTestingBy",
      ListTestingBy?.map((x) => {
        return {
          ...x,
          display: x.EmployeeName?.toLowerCase().includes(
            e?.target?.value?.toLowerCase()
          )
            ? true
            : false,
        };
      })
    );
  };

  const [showDefineMoreRatesModal, setShowDefineMoreRatesModal] =
    useState(false);

  const getDefineMoreRatesModal = async () => {
    formikDefineMoreRates.setFieldValue(
      "MoreTestRatesList",
      ListOfTestDefineMoreRates?.map((itemsubRate) => ({
        TestMasterDefineMoreRatesIDEncrypted:
          itemsubRate?.TestMasterDefineMoreRatesIDEncrypted,
        InwardMaterialTestDetailIDEncrypted:
          itemsubRate?.InwardMaterialTestDetailIDEncrypted,
        TestMasterIDEncrypted: itemsubRate?.TestMasterIDEncrypted,
        RateType: itemsubRate?.RateType,
        RateTypeName: itemsubRate?.RateTypeName,
        IsSelected: itemsubRate?.IsSelected,
      }))
    );

    setShowDefineMoreRatesModal(true);
  };

  const validationSchemaDefineMoreRates = Yup.object().shape({});

  const formikDefineMoreRates = useFormik({
    validationSchema: validationSchemaDefineMoreRates,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitDefineMoreRates(values, formikHelpers),
    initialValues: {
      MoreTestRatesList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { MoreTestRatesList },
  } = formikDefineMoreRates;

  const handleValidSubmitDefineMoreRates = (values) => {
    formik.setFieldValue("ListOfTestDefineMoreRates", "");
    formik.setFieldValue(
      "ListOfTestDefineMoreRates",
      values?.MoreTestRatesList
    );

    if (
      values?.MoreTestRatesList?.filter(
        (e) => e?.IsSelected == true && e?.RateType == 4 //Based On Measurement
      )?.length == 0
    ) {
      formik.setFieldValue("BasedOnMeasurementValue", "");
    }

    if (
      values?.MoreTestRatesList?.filter(
        (e) => e?.IsSelected == true && e?.RateType == 7 //Based On Hrs
      )?.length == 0
    ) {
      formik.setFieldValue("BasedOnHrsValue", "");
    }

    setShowDefineMoreRatesModal(false);
  };

  const addTestingParameters = (indxTest) => {
    formik.setFieldValue(`ListOfTestingUTDetail`, [
      ...ListOfTestingUTDetail,
      initialListOfTestingUTDetail,
    ]);
  };

  const removeTestingParameters = (indxTest) => {
    let newList = ListOfTestingUTDetail?.filter(
      (x) => x?.IsDelete == false
    )?.map((item, idx) => {
      if (indxTest == idx) {
        return {
          ...item,
          IsDelete: true,
        };
      } else {
        return { ...item };
      }
    });

    formik.setFieldValue("ListOfTestingUTDetail", newList);
  };

  const addTestingParametersEquipment = (indxTest) => {
    formik.setFieldValue(`ListOfTestingUTEquipmentDetail`, [
      ...ListOfTestingUTEquipmentDetail,
      initialListOfTestingUTEquipmentDetail,
    ]);
  };

  const removeTestingParametersEquipment = (indxTest) => {
    let newList = ListOfTestingUTEquipmentDetail?.filter(
      (x) => x?.IsDelete == false
    )?.map((item, idx) => {
      if (indxTest == idx) {
        return {
          ...item,
          IsDelete: true,
        };
      } else {
        return { ...item };
      }
    });

    formik.setFieldValue("ListOfTestingUTEquipmentDetail", newList);
  };

  const addProbeDetail = (indxTest) => {
    formik.setFieldValue(`ListOfTestingUTProbDetail`, [
      ...ListOfTestingUTProbDetail,
      initialListOfTestingUTProbDetail,
    ]);
  };

  const removeProbeDetail = (indxTest) => {
    let newList = ListOfTestingUTProbDetail?.filter(
      (x) => x?.IsDelete == false
    )?.map((item, idx) => {
      if (indxTest == idx) {
        return {
          ...item,
          IsDelete: true,
        };
      } else {
        return { ...item };
      }
    });

    formik.setFieldValue("ListOfTestingUTProbDetail", newList);
  };

  const formikTestingRemarks = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestingRemarks(values, formikHelpers),
    initialValues: {
      TestingRemarksList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { TestingRemarksList },
  } = formikTestingRemarks;

  const handleValidSubmitTestingRemarks = (values) => {
    formik.setFieldValue(
      "Remarks",
      TestingRemarksList?.filter((x) => x.IsSelected == true)
        ?.map((wd) => {
          return wd.TestingRemarks;
        })
        .join(" ")
    );
    setShowTestingRemarksModal(false);
  };

  const getTestingUTDetailByID = async (inwardMaterialTestDetailID) => {
    setIsLoading(true);
    await post(POST_GetTestingUTDetailByID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InwardMaterialIDEncrypted: InwardMaterialIDEncrypt,
      InwardMaterialTestDetailIDEncrypted: inwardMaterialTestDetailID,
      TranDate: "",
      EmployeeIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "AllowTestingEdit",
            response?.AllowTestingEdit ?? 0
          );
          formik.setFieldValue(
            "TestMasterIDEncrypt",
            response?.TestMasterIDEncrypt
          );
          formik.setFieldValue("TestingIDEncrypt", response?.TestingIDEncrypt);
          formik.setFieldValue("InwardIDEncrypt", response?.InwardIDEncrypt);
          formik.setFieldValue(
            "CustomerProjectIDEncrypted",
            response?.CustomerProjectIDEncrypt
          );
          formik.setFieldValue("InwardNo", response?.InwardNo);
          formik.setFieldValue("InwardDate", response?.InwardDate);
          formik.setFieldValue(
            "ExpectedDateOfDelivery",
            response?.ExpectedDateOfDelivery
          );
          formik.setFieldValue(
            "IsMaterialReturnable",
            response?.IsMaterialReturnable
          );
          formik.setFieldValue("IsTPIRequired", response?.IsTPIRequired);
          formik.setFieldValue("LetterRefNo", response?.LetterRefNo);
          formik.setFieldValue(
            "ListOfLetterRefDoc",
            response?.ImagesList?.map((item) => ({
              InwardLetterRefImageIDEncrypted:
                item.InwardLetterRefImageIDEncrypt,
              LetterRefImageFile: "",
              viewFile: "",
              LetterRefImageFileName: item?.LetterRefImageFileName,

              LetterRefImageFilePath: item.LetterRefImageFilePath,
              IsDeleted: false,
            }))
          );
          formik.setFieldValue("TCNo", response?.TCNo);

          formik.setFieldValue("IsNDT", response?.IsNDT);
          //formik.setFieldValue("IsNDT", true);
          formik.setFieldValue("Location", response?.Location);
          formik.setFieldValue("DieNo", response?.DieNo);
          formik.setFieldValue("HeatNo", response?.HeatNo);
          formik.setFieldValue("DRGNo", response?.DRGNo);
          formik.setFieldValue("Thikness", response?.Thikness);
          formik.setFieldValue("AreatoBeCovered", response?.AreatoBeCovered);
          formik.setFieldValue("RadiationEnergy", response?.RadiationEnergy);
          formik.setFieldValue("Density", response?.Density);
          formik.setFieldValue("Sensitivity", response?.Sensitivity);
          formik.setFieldValue("TestType", response?.TestType);
          formik.setFieldValue("NDTProcessType", response?.NDTProcessType);
          // formik.setFieldValue(
          //   "InwardMaterialIDEncrypt",
          //   response?.InwardMaterialIDEncrypt
          // );

          formik.setFieldValue(
            "DepartmentIDEncrypt",
            response?.TestDetails[0]?.DepartmentIDEncrypt
          );
          formik.setFieldValue(
            "DepartmentName",
            response?.TestDetails[0]?.DepartmentName
          );

          formik.setFieldValue(
            "ProductGroupIDEncrypt",
            response?.TestDetails[0]?.MaterialGroupIDEncrypt
          );
          formik.setFieldValue(
            "ProductGroupName",
            response?.TestDetails[0]?.MaterialGroupName
          );
          formik.setFieldValue(
            "MaterialTypeIDEncrypt",
            response?.TestDetails[0]?.MaterialTypeIDEncrypt
          );
          formik.setFieldValue(
            "MaterialTypeName",
            response?.TestDetails[0]?.MaterialType
          );
          formik.setFieldValue(
            "SampleNote",
            response?.TestDetails[0]?.TestNote
          );
          formik.setFieldValue(
            "TestingDate",
            response?.TestingDate ? new Date(response?.TestingDate) : new Date()
          );
          formik.setFieldValue(
            "TestingToDate",
            response?.TestingToDate
              ? new Date(response?.TestingToDate)
              : new Date()
          );
          formik.setFieldValue(
            "TestingQty",
            response?.TestDetails[0]?.TestingQty
          );
          formik.setFieldValue(
            "InvoiceQty",
            response?.TestDetails[0]?.InvoiceQty
          );
          formik.setFieldValue("UnitID", response?.TestDetails[0]?.UnitID);
          formik.setFieldValue(
            "BasedOnMeasurementValue",
            response?.TestDetails[0]?.BasedOnMeasurementValue
              ? response?.TestDetails[0]?.BasedOnMeasurementValue
              : ""
          );
          formik.setFieldValue(
            "BasedOnHrsValue",
            response?.TestDetails[0]?.BasedOnHrsValue
              ? response?.TestDetails[0]?.BasedOnHrsValue
              : ""
          );

          formikDefineMoreRates.setFieldValue(
            "MoreTestRatesList",
            response?.ListOfTestDefineMoreRates?.map((itemsubRate) => ({
              TestMasterDefineMoreRatesIDEncrypted:
                itemsubRate?.TestMasterDefineMoreRatesIDEncrypted,
              InwardMaterialTestDetailIDEncrypted:
                itemsubRate?.InwardMaterialTestDetailIDEncrypted,
              TestMasterIDEncrypted: itemsubRate?.TestMasterIDEncrypted,
              RateType: itemsubRate?.RateType,
              RateTypeName: itemsubRate?.RateTypeName,
              IsSelected: itemsubRate?.IsSelected,
            }))
          );

          formik.setFieldValue(
            "ListOfTestDefineMoreRates",
            response?.ListOfTestDefineMoreRates?.map((itemsubRate) => ({
              TestMasterDefineMoreRatesIDEncrypted:
                itemsubRate?.TestMasterDefineMoreRatesIDEncrypted,
              InwardMaterialTestDetailIDEncrypted:
                itemsubRate?.InwardMaterialTestDetailIDEncrypted,
              TestMasterIDEncrypted: itemsubRate?.TestMasterIDEncrypted,
              RateType: itemsubRate?.RateType,
              RateTypeName: itemsubRate?.RateTypeName,
              IsSelected: itemsubRate?.IsSelected,
            }))
          );

          formik.setFieldValue(
            "TestMethodIDEncrypt",
            response?.TestDetails[0]?.TestMethodIDEncrypt
          );
          formik.setFieldValue(
            "ReferenceStandardIDEncrypted",
            response?.TestDetails[0]?.ReferenceStandardIDEncrypt
          );
          formik.setFieldValue(
            "AcceptanceStandardEncrypted",
            response?.TestDetails[0]?.AcceptanceStandardEncrypted
          );
          formik.setFieldValue("MachineIDEncrypt", response?.MachineIDEncrypt);
          formik.setFieldValue("Size", response?.Size);
          formik.setFieldValue("Condition", response?.Condition);
          formik.setFieldValue("SampleDetail", response?.SampleDetail);
          formik.setFieldValue("IsReTestTesting", response?.IsReTestTesting);
          formik.setFieldValue("TestName", response?.TestName);
          formik.setFieldValue("TestingDateDisplay", response?.TestingDate);
          formik.setFieldValue("TestingToDateDisplay", response?.TestingToDate);
          formik.setFieldValue("MachineName", response?.MachineName);
          formik.setFieldValue("UnitName", response?.UnitName);
          formik.setFieldValue("TestMethodName", response?.TestMethodName);
          formik.setFieldValue(
            "ReferenceStandardName",
            response?.ReferenceStandardName
          );
          formik.setFieldValue(
            "AcceptanceStandardName",
            response?.AcceptanceStandardName
          );

          setTestMethodOptions(
            response?.ListOfTestMethod.map((item) => ({
              label: item.NickName
                ? `${item.TestMethod} (${item.NickName})`
                : item.TestMethod,
              value: item?.TestMethodIDEncrypted,
              IsExpiredTestMethod: item?.IsExpiredTestMethod,
            }))
          );

          setMachineOptions(
            response?.ListOfMachines?.map((item) => ({
              label: item?.MachineName,
              value: item?.MachineIDEncrypted,
              IsCalibrationValidity: item?.IsCalibrationValidity,
              IsCalibrationValidityExpire: item?.IsCalibrationValidityExpire,
              Make: item?.ManufacturingCompany,
              SrNo: item?.SerialNo,
              CaliDueDate: item?.CalibrationExpiryDate,
            }))
          );

          formik.setFieldValue(
            "acceptanceStandardOptions",
            response?.AcceptanceStandardList?.map((item) => ({
              label: item.ReferenceStandard,
              value: item.ReferenceStandardIDEncrypted,
              IsExpiredReferenceStandard: item?.IsExpiredReferenceStandard,
            }))
          );

          formik.setFieldValue(
            "referenceStandardOptions",
            response?.ListOfReferenceStandards?.map((item) => ({
              label: item.ReferenceStandard,
              value: item.ReferenceStandardIDEncrypted,
              IsExpiredReferenceStandard: item?.IsExpiredReferenceStandard,
            }))
          );

          formik.setFieldValue(
            "productGroupOptions",
            response?.ListOfProductGroup?.map((item) => ({
              label: item.ProductGroupName,
              value: item.ProductGroupIDEncrypt,
            }))
          );

          formik.setFieldValue(
            "materialTypeOptions",
            response?.ListOfMaterialType?.map((item) => ({
              label: item.MaterialTypeName,
              value: item.MaterialTypeIDEncrypted,
            }))
          );

          formik.setFieldValue(
            "ListTestingBy",
            response?.TestingByList?.map((item) => ({
              EmployeeIDEncrypt: item.EmployeeIDEncrypted,
              EmployeeName: item.EmployeeName,
              IsSelected: item.IsSelected,
              display: true,
            }))
          );

          formik.setFieldValue(
            "ListOfTPIDetails",
            response?.TPIList?.map((x) => {
              return {
                ...x,
                TPIIDEncrypted: x?.TPIIDEncrypt,
                TPIContactPersonIDEncrypted: x?.TPIContactPersonIDEncrypt,
                TPIExpectedDate: x?.TPIExpectedDate
                  ? new Date(x?.TPIExpectedDate)
                  : "",
                displayTPIExpectedDate: x?.TPIExpectedDate,
                IsDeleted: false,
              };
            })
          );

          formik.setFieldValue(
            "ListTestMasterImages",
            response?.ListOfTestImage?.map((item) => ({
              ...item,
            }))
          );

          formik.setFieldValue(
            "ListTestingResultImages",
            response?.ListOfTestResultImages?.map((item) => ({
              ...item,
              TestingResultImageFile: "",
              viewFile: "",
              IsDeleted: false,
            }))
          );

          formik.setFieldValue("LocationType", response?.LocationType);
          formik.setFieldValue("Result", response?.Result);
          formik.setFieldValue("Remarks", response?.Remarks);
          formik.setFieldValue("ChangeNote", response?.ChangeNote);
          formik.setFieldValue("TestingStatus", response?.TestingStatus);

          // formik.setFieldValue("ListOfTestingUTDetail", [
          //   ...response?.ListOfTestingUTDetail,
          //   initialListOfTestingUTDetail,
          // ]);

          formik.setFieldValue("ListOfTestingUTDetail", [
            ...response?.ListOfTestingUTDetail?.map((x) => {
              return {
                ...x,
                ChallanDate: x?.ChallanDate ? new Date(x?.ChallanDate) : "",
                OfferDate: x?.OfferDate ? new Date(x?.OfferDate) : "",
              };
            }),
            initialListOfTestingUTEquipmentDetail,
          ]);

          formik.setFieldValue("ListOfTestingUTEquipmentDetail", [
            ...response?.ListOfTestingUTEquipmentDetail,
            initialListOfTestingUTEquipmentDetail,
          ]);

          formik.setFieldValue("ListOfTestingUTProbDetail", [
            ...response?.ListOfTestingUTProbDetail,
            initialListOfTestingUTProbDetail,
          ]);

          formik.setFieldValue(
            "TestingUTIDEncrypt",
            response?.UTDetails[0]?.TestingUTIDEncrypt
          );

          formik.setFieldValue(
            "JobType",
            response?.UTDetails[0]?.JobType ?? ""
          );
          formik.setFieldValue(
            "JobDescripation",
            response?.UTDetails[0]?.JobDescripation ?? ""
          );
          formik.setFieldValue(
            "ProcedureID",
            response?.UTDetails[0]?.ProcedureID ?? 0
          );
          formik.setFieldValue(
            "SurfaceCondition",
            response?.UTDetails[0]?.SurfaceCondition ?? ""
          );

          formik.setFieldValue(
            "AdditionsToDeviations",
            response?.UTDetails[0]?.AdditionsToDeviations ?? 0
          );
          formik.setFieldValue(
            "ExtentOfExa",
            response?.UTDetails[0]?.ExtentOfExa ?? ""
          );
          formik.setFieldValue(
            "StageOfExa",
            response?.UTDetails[0]?.StageOfExa ?? ""
          );

          formik.setFieldValue(
            "SurfaceTemp",
            response?.UTDetails[0]?.SurfaceTemp ?? ""
          );
          formik.setFieldValue(
            "Couplant",
            response?.UTDetails[0]?.Couplant ?? ""
          );
          formik.setFieldValue("Method", response?.UTDetails[0]?.Method ?? "");

          formik.setFieldValue(
            "WeldingProcess",
            response?.UTDetails[0]?.WeldingProcess ?? ""
          );
          formik.setFieldValue(
            "BasicCaliBlock",
            response?.UTDetails[0]?.BasicCaliBlock ?? ""
          );
          formik.setFieldValue(
            "RefSensitivity",
            response?.UTDetails[0]?.RefSensitivity ?? ""
          );
          formik.setFieldValue(
            "TestCarriedOutat",
            response?.UTDetails[0]?.TestCarriedOutat ?? ""
          );
          formik.setFieldValue(
            "WorksheetNo",
            response?.UTDetails[0]?.WorksheetNo ?? ""
          );
          formik.setFieldValue(
            "UploadFilePath",
            response?.UTDetails[0]?.UploadFilePath ?? ""
          );
          formik.setFieldValue(
            "UploadFilePathURL",
            response?.UTDetails[0]?.UploadFilePathURL ?? ""
          );

          formik.setFieldValue(
            "JobDescripationLabel",
            response?.UTDetails[0]?.JobDescripationLabel
              ? response?.UTDetails[0]?.JobDescripationLabel
              : "Job Descripation"
          );

          formik.setFieldValue(
            "UTNoLabel",
            response?.UTDetails[0]?.UTNoLabel
              ? response?.UTDetails[0]?.UTNoLabel
              : "Tested Area"
          );

          formik.setFieldValue(
            "HeatNoLabel",
            response?.UTDetails[0]?.HeatNoLabel
              ? response?.UTDetails[0]?.HeatNoLabel
              : "Size(mm)"
          );
          formik.setFieldValue(
            "QtyLabel",
            response?.UTDetails[0]?.QtyLabel
              ? response?.UTDetails[0]?.QtyLabel
              : "Quantity"
          );
          formik.setFieldValue(
            "JointNoLabel",
            response?.UTDetails[0]?.JointNoLabel
              ? response?.UTDetails[0]?.JointNoLabel
              : "I.D. No"
          );
        } else {
          //Reset Details
          formik.setFieldValue("AllowTestingEdit", 0);
          formik.setFieldValue("TestMasterIDEncrypt", "");
          formik.setFieldValue("TestingIDEncrypt", "");
          formik.setFieldValue("InwardIDEncrypt", "");
          formik.setFieldValue("CustomerProjectIDEncrypted", "");
          formik.setFieldValue("InwardNo", "");
          formik.setFieldValue("InwardDate", "");
          formik.setFieldValue("ExpectedDateOfDelivery", "");
          formik.setFieldValue("IsMaterialReturnable", false);
          formik.setFieldValue("IsTPIRequired", false);
          formik.setFieldValue("LetterRefNo", "");
          formik.setFieldValue("ListOfLetterRefDoc", []);
          formik.setFieldValue("TCNo", "");
          formik.setFieldValue("DepartmentIDEncrypt", "");
          formik.setFieldValue("DepartmentName", "");
          formik.setFieldValue("ProductGroupIDEncrypt", "");
          formik.setFieldValue("ProductGroupName", "");
          formik.setFieldValue("MaterialTypeIDEncrypt", "");
          formik.setFieldValue("MaterialTypeName", "");
          formik.setFieldValue("SampleNote", "");
          formik.setFieldValue("TestingDate", new Date());
          formik.setFieldValue("TestingToDate", new Date());
          formik.setFieldValue("TestingQty", "");
          formik.setFieldValue("InvoiceQty", "");
          formik.setFieldValue("UnitID", "");
          formik.setFieldValue("TestMethodIDEncrypt", "");
          formik.setFieldValue("ReferenceStandardIDEncrypted", "");
          formik.setFieldValue("MachineIDEncrypt", "");
          formik.setFieldValue("Size", "");
          formik.setFieldValue("Condition", "");
          formik.setFieldValue("SampleDetail", "");
          formik.setFieldValue("LocationType", 1);
          setTestMethodOptions([]);
          setMachineOptions([]);
          //setReferenceStandardOptions([]);

          formik.setFieldValue("ListTestingBy", []);
          formik.setFieldValue("ListOfTPIDetails", []);
          formik.setFieldValue("ListTestMasterImages", []);
          formik.setFieldValue("ListTestingResultImages", []);
          formik.setFieldValue("Result", "");
          formik.setFieldValue("Remarks", "");
          formik.setFieldValue("ChangeNote", "");
          formik.setFieldValue("TestingStatus", "");
          formik.setFieldValue("ReferenceSubGroup", "");
          formik.setFieldValue("ParameterWith", 1);
          formik.setFieldValue("IsMergeSameValue", false);

          formik.setFieldValue("BasedOnMeasurementValue", "");
          formik.setFieldValue("BasedOnHrsValue", "");
          formik.setFieldValue("ListOfTestDefineMoreRates", []);
          formikDefineMoreRates.setFieldValue("MoreTestRatesList", []);
          formik.setFieldValue("Location", "");
          formik.setFieldValue("DieNo", "");
          formik.setFieldValue("HeatNo", "");
          formik.setFieldValue("DRGNo", "");
          formik.setFieldValue("Thikness", "");
          formik.setFieldValue("AreatoBeCovered", "");
          formik.setFieldValue("RadiationEnergy", "");
          formik.setFieldValue("Density", "");
          formik.setFieldValue("Sensitivity", "");
          formik.setFieldValue("AcceptanceStandardEncrypted", "");
          formik.setFieldValue("AcceptanceStandardName", "");
          formik.setFieldValue("AdditionsToDeviations", 0);
          formik.setFieldValue("JobType", "");
          formik.setFieldValue("JobDescripation", "");
          formik.setFieldValue("JobDescripationLabel", "");
          formik.setFieldValue("ProcedureID", 0);
          formik.setFieldValue("SurfaceCondition", "");
          formik.setFieldValue("ExtentOfExa", "");
          formik.setFieldValue("StageOfExa", "");
          formik.setFieldValue("SurfaceTemp", "");
          formik.setFieldValue("Couplant", "");

          formik.setFieldValue("Method", "");
          formik.setFieldValue("WeldingProcess", "");
          formik.setFieldValue("BasicCaliBlock", "");
          formik.setFieldValue("RefSensitivity", "");
          formik.setFieldValue("WorksheetNo", "");
          formik.setFieldValue("TestCarriedOutat", "");
          formik.setFieldValue("UTNoLabel", "");
          formik.setFieldValue("HeatNoLabel", "");
          formik.setFieldValue("QtyLabel", "");
          formik.setFieldValue("JointNoLabel", "");

          formik.setFieldValue("UploadFilePath", "");
          formik.setFieldValue("UploadFilePathURL", "");
          formik.setFieldValue("UploadFilePathFileKey", "");
          setUploadUTFilePath(null);
          formik.setFieldValue("ListOfTestingUTDetail", [
            initialListOfTestingUTDetail,
          ]);
          formik.setFieldValue("ListOfTestingUTEquipmentDetail", [
            initialListOfTestingUTEquipmentDetail,
          ]);
          formik.setFieldValue("ListOfTestingUTProbDetail", [
            initialListOfTestingUTProbDetail,
          ]);
          formik.setFieldValue("acceptanceStandardOptions", []);
          formik.setFieldValue("materialTypeOptions", []);
          formik.setFieldValue("productGroupOptions", []);
          formik.setFieldValue("referenceStandardOptions", []);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadDocFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      var pattern = /(.png|.gif|.jpeg|.jpg)$/;

      if (!file.type.match(pattern)) {
        warningMessage("Select valid file!");
        // formik.setFieldValue("UploadFilePath", "");
        setUploadUTFilePath(null);
        formik.setFieldValue(
          "UploadFilePathFileKey",
          Math.random().toString(9).substring(2, 9)
        );
      } else {
        //formik.setFieldValue("UploadFilePath", file);
        setUploadUTFilePath(file);
      }
    } else {
      //formik.setFieldValue("UploadFilePath", "");
      setUploadUTFilePath(null);
      formik.setFieldValue(
        "UploadFilePathFileKey",
        Math.random().toString(9).substring(2, 9)
      );
    }
  };

  const handleChangeEquipmentDetail = (e, indxTest) => {
    let ItemExist = false;
    ListOfTestingUTEquipmentDetail?.filter((x) => x?.IsDelete == false).map(
      (x, idx) => {
        if (x.EquipmentIDEncrypt === e?.value) {
          ItemExist = true;
        }
      }
    );

    if (ItemExist === true) {
      formik.setFieldValue(
        `ListOfTestingUTEquipmentDetail[${indxTest}].EquipmentIDEncrypt`,
        ""
      );
      formik.setFieldValue(
        `ListOfTestingUTEquipmentDetail[${indxTest}].Make`,
        ""
      );
      formik.setFieldValue(
        `ListOfTestingUTEquipmentDetail[${indxTest}].SerialNo`,
        ""
      );
      formik.setFieldValue(
        `ListOfTestingUTEquipmentDetail[${indxTest}].CalibrationDueDate`,
        ""
      );
      warningMessage("Equipment allready exist..!");
      return;
    } else {
      formik.setFieldValue(
        `ListOfTestingUTEquipmentDetail[${indxTest}].EquipmentIDEncrypt`,
        e?.value ?? ""
      );
      formik.setFieldValue(
        `ListOfTestingUTEquipmentDetail[${indxTest}].Make`,
        e?.Make ?? ""
      );
      formik.setFieldValue(
        `ListOfTestingUTEquipmentDetail[${indxTest}].SerialNo`,
        e?.SrNo ?? ""
      );
      formik.setFieldValue(
        `ListOfTestingUTEquipmentDetail[${indxTest}].CalibrationDueDate`,
        e?.CaliDueDate ?? ""
      );
    }
  };

  return (
    <>
      <div className="p-2 pt-0">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <hr className="mt-0 mb-1"></hr>
            <Row>
              <Col lg={6}>
                <div className="d-flex justify-content-between mb-0">
                  <div className="d-flex mb-0">
                    <label>Testing Details (UT - Ultrasonic Testing)</label>
                  </div>
                </div>
                <div className="card mb-2" style={{ height: "auto" }}>
                  <div className="card-body p-2">
                    <Row>
                      <Col lg={12}>
                        <div className="col-xl-12 col-lg-12">
                          <div className="row">
                            <Col lg={6}>
                              {IsReTestTesting ? (
                                <Field
                                  label="Testing From Date"
                                  name="TestingDateDisplay"
                                  component={CustomInput}
                                  required
                                  disabled={true}
                                />
                              ) : (
                                <Field
                                  label="Testing From Date"
                                  name="TestingDate"
                                  placeholder={"Select Testing From Date"}
                                  component={CustomFlatpickr}
                                  options={{
                                    altInput: true,
                                    altFormat: "j-M-Y",
                                    dateFormat: "d-m-Y",
                                    minDate: InwardDate
                                      ? new Date(InwardDate)
                                      : "",
                                    maxDate: new Date(),
                                  }}
                                  onChange={(e) => {
                                    formik.setFieldValue("TestingDate", e);
                                    getDepartmentDDLForScopeValidityCheck(e);
                                  }}
                                />
                              )}
                            </Col>
                            <Col lg={6}>
                              {IsReTestTesting ? (
                                <Field
                                  label="Testing To Date"
                                  name="TestingToDateDisplay"
                                  component={CustomInput}
                                  required
                                  disabled={true}
                                />
                              ) : (
                                <Field
                                  label="Testing To Date"
                                  name="TestingToDate"
                                  placeholder={"Select Testing To Date"}
                                  component={CustomFlatpickr}
                                  options={{
                                    altInput: true,
                                    altFormat: "j-M-Y",
                                    dateFormat: "d-m-Y",
                                    minDate: TestingDate
                                      ? new Date(TestingDate)
                                      : "",
                                  }}
                                />
                              )}
                            </Col>
                            <Col lg={6}>
                              {IsReTestTesting == false ? (
                                <Field
                                  label="Material Group"
                                  name="ProductGroupIDEncrypt"
                                  placeholder={"Select Material Group"}
                                  component={CustomSelect}
                                  options={productGroupOptions}
                                  isClearable={false}
                                  required
                                />
                              ) : (
                                <Field
                                  label="Material Group"
                                  name="ProductGroupName"
                                  component={CustomInput}
                                  required
                                  disabled={true}
                                />
                              )}
                            </Col>
                            <Col lg={6}>
                              {IsReTestTesting == false ? (
                                <Field
                                  label="Material Type"
                                  name="MaterialTypeIDEncrypt"
                                  placeholder={"Select Material Type"}
                                  component={CustomSelect}
                                  options={materialTypeOptions}
                                  isClearable={false}
                                  required
                                />
                              ) : (
                                <Field
                                  label="Material Type"
                                  name="MaterialTypeName"
                                  component={CustomInput}
                                  required
                                  disabled={true}
                                />
                              )}
                            </Col>
                          </div>
                          <div className="row">
                            <Col lg={6}>
                              {IsReTestTesting == false ? (
                                <Field
                                  label="Reference Standard"
                                  name="ReferenceStandardIDEncrypted"
                                  placeholder={"Select Reference Standard"}
                                  component={CustomSelect}
                                  options={referenceStandardOptions}
                                  onChange={(e) => {
                                    if (e?.IsExpiredReferenceStandard == true) {
                                      warningMessage(
                                        "Reference Standard is Expired..!"
                                      );
                                      formik.setFieldValue(
                                        "ReferenceStandardIDEncrypted",
                                        ""
                                      );
                                    } else {
                                      formik.setFieldValue(
                                        "ReferenceStandardIDEncrypted",
                                        e?.value ?? ""
                                      );
                                    }
                                  }}
                                />
                              ) : (
                                <Field
                                  label="Reference Standard"
                                  name="ReferenceStandardName"
                                  component={CustomInput}
                                  required
                                  disabled={true}
                                />
                              )}
                            </Col>
                            <Col lg={6}>
                              {IsReTestTesting == false ? (
                                <Field
                                  label="Acceptance Standard"
                                  name="AcceptanceStandardEncrypted"
                                  placeholder={"Select Acceptance Standard"}
                                  component={CustomSelect}
                                  options={acceptanceStandardOptions}
                                  required
                                  onChange={(e) => {
                                    if (e?.IsExpiredReferenceStandard == true) {
                                      warningMessage(
                                        "Acceptance Standard is Expired..!"
                                      );
                                      formik.setFieldValue(
                                        "AcceptanceStandardEncrypted",
                                        ""
                                      );
                                    } else {
                                      formik.setFieldValue(
                                        "AcceptanceStandardEncrypted",
                                        e?.value ?? ""
                                      );
                                    }
                                  }}
                                />
                              ) : (
                                <Field
                                  label="Acceptance Standard"
                                  name="AcceptanceStandardName"
                                  component={CustomInput}
                                  required
                                  disabled={true}
                                />
                              )}
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Job Type"
                                name="JobType"
                                placeholder={"Enter Job Type"}
                                component={CustomInput}
                                maxLength={500}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Job Descripation"
                                name="JobDescripation"
                                placeholder={"Enter Job Descripation"}
                                component={CustomInput}
                                maxLength={500}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>

                            <Col lg={6}>
                              <Field
                                label="Procedure No"
                                name="ProcedureID"
                                placeholder={"Select Procedure No"}
                                component={CustomSelect}
                                options={MainFormik.ProcedureOptions}
                                isClearable={false}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Sur Condition"
                                name="SurfaceCondition"
                                placeholder={"Enter Sur Condition"}
                                component={CustomInput}
                                maxLength={500}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Additions To Deviations"
                                name="AdditionsToDeviations"
                                placeholder={"Select Additions To Deviations"}
                                component={CustomSelect}
                                options={additionsToDeviationsOptions}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Extent Of Exa"
                                name="ExtentOfExa"
                                placeholder={"Enter Extent Of Exa"}
                                component={CustomInput}
                                maxLength={500}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Stage Of Exa"
                                name="StageOfExa"
                                placeholder={"Enter Stage Of Exa"}
                                component={CustomInput}
                                maxLength={500}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Surface Temp"
                                name="SurfaceTemp"
                                placeholder={"Enter Surface Temp"}
                                component={CustomInput}
                                maxLength={500}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Couplant"
                                name="Couplant"
                                placeholder={"Enter Couplant"}
                                component={CustomInput}
                                maxLength={500}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Method"
                                name="Method"
                                placeholder={"Enter Method"}
                                component={CustomInput}
                                maxLength={500}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Welding Process"
                                name="WeldingProcess"
                                placeholder={"Enter Welding Process"}
                                component={CustomInput}
                                maxLength={500}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Basic Cali. Block"
                                name="BasicCaliBlock"
                                placeholder={"Enter Basic Cali Block"}
                                component={CustomInput}
                                maxLength={500}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Ref. Sensitivity"
                                name="RefSensitivity"
                                placeholder={"Enter Ref. Sensitivity"}
                                component={CustomInput}
                                maxLength={500}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Test Carried Out at"
                                name="TestCarriedOutat"
                                placeholder={"Enter Test Carried Out at"}
                                component={CustomInput}
                                maxLength={500}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Worksheet No"
                                name="WorksheetNo"
                                placeholder={"Enter Worksheet No"}
                                component={CustomInput}
                                maxLength={500}
                                disabled={IsReTestTesting ? true : false}
                              />
                            </Col>
                            <Col lg={6}>
                              <div className="d-flex justify-content-between">
                                <label className="mb-1">Upload</label>
                                {UploadFilePathURL ? (
                                  <Link
                                    to="#"
                                    title="Download"
                                    className="fs-14"
                                    onClick={() => {
                                      window.open(UploadFilePathURL, "_blank");
                                    }}
                                  >
                                    {SVGICON.Download}
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </div>
                              <input
                                type="file"
                                className="form-control form-control-sm"
                                id="fileUpload"
                                accept="image/png, image/gif, image/jpeg"
                                key={UploadFilePathFileKey || ""}
                                onChange={(e) => {
                                  uploadDocFile(e);
                                }}
                              />
                            </Col>
                          </div>
                          <div className="row">
                            <Col lg={6}>
                              <Row>
                                <Col lg={6}>
                                  <Field
                                    label="Job Descripation Label"
                                    name="JobDescripationLabel"
                                    placeholder={"Job Descripation Label"}
                                    component={CustomInput}
                                    maxLength={25}
                                    disabled={IsReTestTesting ? true : false}
                                  />
                                </Col>

                                <Col lg={6}>
                                  <Field
                                    label="UT No Label"
                                    name="UTNoLabel"
                                    placeholder={"UT No Label"}
                                    component={CustomInput}
                                    maxLength={25}
                                    disabled={IsReTestTesting ? true : false}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="Heat No Label"
                                    name="HeatNoLabel"
                                    placeholder={"Heat No Label"}
                                    component={CustomInput}
                                    maxLength={25}
                                    disabled={IsReTestTesting ? true : false}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="Qty. Label"
                                    name="QtyLabel"
                                    placeholder={"Qty Label"}
                                    component={CustomInput}
                                    maxLength={25}
                                    disabled={IsReTestTesting ? true : false}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="Joint No Label"
                                    name="JointNoLabel"
                                    placeholder={"Joint No Label"}
                                    component={CustomInput}
                                    maxLength={25}
                                    disabled={IsReTestTesting ? true : false}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col lg={6} className="mb-2">
                              <label className="mb-1">
                                Testing By{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <div
                                className="card mb-0 w-100"
                                style={{ height: "180px" }}
                              >
                                <div className="card-header p-0">
                                  <input
                                    type="text"
                                    name="searchTestingBy"
                                    placeholder={"Search here..."}
                                    className="form-control form-control-sm"
                                    value={searchTestingBy}
                                    onChange={handleChangeSearchTestingBy}
                                    style={{
                                      borderBottomLeftRadius: "0",
                                      borderBottomRightRadius: "0",
                                    }}
                                  ></input>
                                </div>
                                <div
                                  className="card-body p-0 table-responsive"
                                  style={{
                                    maxHeight: "135px",
                                    overflow: "auto",
                                  }}
                                >
                                  <table className="table table-hover header-border no-footer">
                                    <tbody>
                                      {ListTestingBy?.filter(
                                        (x) => x.display == true
                                      )?.length > 0 ? (
                                        ListTestingBy?.map((item, indx) => (
                                          <tr
                                            key={indx}
                                            style={{
                                              display:
                                                item.display == true
                                                  ? ""
                                                  : "none",
                                            }}
                                          >
                                            <td
                                              style={{
                                                textAlign: "center",
                                                padding: "0.5rem",
                                                width: "15%",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={`chkTestingBy${indx}`}
                                                name={`chkTestingBy${indx}`}
                                                checked={item.IsSelected}
                                                onChange={(e) => {
                                                  formik.setFieldValue(
                                                    `ListTestingBy[${indx}].IsSelected`,
                                                    e.target.checked
                                                  );
                                                }}
                                                disabled={
                                                  IsReTestTesting ? true : false
                                                }
                                              />
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "left",
                                                padding: "0.5rem",
                                                width: "85%",
                                              }}
                                            >
                                              {item.EmployeeName}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={2}
                                            style={{
                                              textAlign: "center",
                                            }}
                                          >
                                            <div>{"No options"}</div>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <ErrorMessage
                                name={"ListTestingBy"}
                                component="div"
                                className="invalid-feedback animated fadeInUp"
                                style={{ display: "block" }}
                              />
                            </Col>
                          </div>
                          <div className="row" style={{ display: "none" }}>
                            {AuthUser?.Permissions?.Account == 1 ? (
                              <Col lg={6}>
                                <div className="mb-2">
                                  <label className="mb-1">
                                    Define More Rates
                                  </label>
                                  <div className="input-group">
                                    <span className="form-control form-control-sm ps-2">
                                      <Link
                                        to="#"
                                        className="text-primary"
                                        onClick={() => {
                                          getDefineMoreRatesModal();
                                        }}
                                      >
                                        Set Define More Rates
                                      </Link>
                                    </span>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}
                            {/* </div>
                                  <div className="row"> */}
                            {ListOfTestDefineMoreRates?.filter(
                              (e) => e.IsSelected == true && e.RateType == 4 //Based On Measurement
                            )?.length > 0 ? (
                              <Col lg={6}>
                                <Field
                                  type="number"
                                  label={"Based On Measurement Value"}
                                  name="BasedOnMeasurementValue"
                                  placeholder={
                                    "Enter Based On Measurement Value"
                                  }
                                  component={CustomInput}
                                  maxLength={20}
                                  disabled={IsReTestTesting ? true : false}
                                  //numberTypeWithoutDot={true}
                                />
                              </Col>
                            ) : (
                              ""
                            )}
                            {ListOfTestDefineMoreRates?.filter(
                              (e) => e.IsSelected == true && e.RateType == 7 //Based On Hrs
                            )?.length > 0 ? (
                              <Col lg={6}>
                                <Field
                                  type="number"
                                  label={"Based On Hrs Value"}
                                  name="BasedOnHrsValue"
                                  placeholder={"Enter Based On Hrs Value"}
                                  component={CustomInput}
                                  maxLength={20}
                                  disabled={IsReTestTesting ? true : false}
                                  //numberTypeWithoutDot={true}
                                />
                              </Col>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={12}>
                    <div className="card mb-2" style={{ height: "auto" }}>
                      <div className="card-body p-2">
                        <Row>
                          <div className="d-flex justify-content-between mb-0">
                            <div className="d-flex mb-0">
                              <label className="text-warning fs-12 mb-1">
                                [Note: Changes to Sample Detail, Condition,
                                Size, Die No, Heat No, DRG No, Thickness(mm),
                                Area to Be Covered, Density, Radiation Energy or
                                Sensitivity will affect previously completed
                                tests of this sample (TC). Therefore, you will
                                need to reprint the report for any tests that
                                have already been printed.]
                              </label>
                            </div>
                          </div>
                          <Col lg={12}>
                            <Field
                              label="Sample Detail"
                              name="SampleDetail"
                              placeholder={"Enter Sample Detail"}
                              component={CustomTextArea}
                              rows={4}
                              maxLength={2000}
                              disabled={IsReTestTesting ? true : false}
                              required
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Condition"
                              name="Condition"
                              placeholder={"Enter Condition"}
                              component={CustomInput}
                              maxLength={500}
                              disabled={IsReTestTesting ? true : false}
                              required
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Size"
                              name="Size"
                              placeholder={"Enter Size"}
                              component={CustomInput}
                              maxLength={500}
                              disabled={IsReTestTesting ? true : false}
                              required
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Die No"
                              name="DieNo"
                              placeholder={"Enter Die No"}
                              component={CustomInput}
                              maxLength={500}
                              disabled={IsReTestTesting ? true : false}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Heat No"
                              name="HeatNo"
                              placeholder={"Enter Heat No"}
                              component={CustomInput}
                              maxLength={500}
                              disabled={IsReTestTesting ? true : false}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="DRG No"
                              name="DRGNo"
                              placeholder={"Enter DRG No"}
                              component={CustomInput}
                              maxLength={500}
                              disabled={IsReTestTesting ? true : false}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Thickness(mm)"
                              name="Thikness"
                              placeholder={"Enter Thickness"}
                              component={CustomInput}
                              maxLength={500}
                              disabled={IsReTestTesting ? true : false}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Area to Be Covered"
                              name="AreatoBeCovered"
                              placeholder={"Enter Area to Be Covered"}
                              component={CustomInput}
                              maxLength={500}
                              disabled={IsReTestTesting ? true : false}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Density"
                              name="Density"
                              placeholder={"Enter Density"}
                              component={CustomInput}
                              maxLength={500}
                              disabled={IsReTestTesting ? true : false}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Radiation Energy"
                              name="RadiationEnergy"
                              placeholder={"Select Radiation Energy"}
                              component={CustomSelect}
                              options={radiationEnergyOptions}
                              disabled={IsReTestTesting ? true : false}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Sensitivity"
                              name="Sensitivity"
                              placeholder={"Select Sensitivity"}
                              component={CustomSelect}
                              options={MainFormik?.sensitivityOptions}
                              disabled={IsReTestTesting ? true : false}
                            />
                          </Col>
                        </Row>
                        {MainFormik?.IsTPIRequired === true ? (
                          <Row>
                            <Col lg={12}>
                              <hr className="mt-0 mb-1"></hr>
                              <div className="d-flex justify-content-between mb-0">
                                <div className="d-flex mb-0">
                                  <label>TPI Details</label>
                                </div>
                                <div>
                                  {IsReTestTesting == false ? (
                                    <Link
                                      to="#"
                                      className="text-primary"
                                      onClick={() => {
                                        addNewTPI();
                                      }}
                                    >
                                      + Add TPI
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="row">
                                <div className="table-responsive active-projects style-1 shorting mb-2">
                                  <div
                                    id="TPIdetail-tbl_wrapper"
                                    className="dataTables_wrapper no-footer"
                                  >
                                    <table
                                      id="TPIdetail-tbl"
                                      className="table dataTable no-footer mb-0"
                                    >
                                      <thead>
                                        <tr>
                                          <th width="2%"></th>
                                          <th width="40%">TPI</th>
                                          <th width="38%">
                                            TPI Contact Person
                                          </th>
                                          <th
                                            width="20%"
                                            style={{
                                              textAlign: "left",
                                            }}
                                          >
                                            TPI Expected Date
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {ListOfTPIDetails?.filter(
                                          (x) => x.IsDeleted == false
                                        )?.length > 0 ? (
                                          ListOfTPIDetails?.map(
                                            (item, indx) => (
                                              <tr
                                                key={indx}
                                                style={{
                                                  display:
                                                    item.IsDeleted == true
                                                      ? "none"
                                                      : "",
                                                }}
                                              >
                                                <td>
                                                  {IsReTestTesting == false ? (
                                                    <Link
                                                      to="#"
                                                      className="icon-box icon-box-md me-1"
                                                      title="Delete"
                                                      onClick={() => {
                                                        delete_RecordWithoutApi(
                                                          deleteTPI,
                                                          indx
                                                        );
                                                      }}
                                                    >
                                                      {SVGICON.DeleteDanger}
                                                    </Link>
                                                  ) : (
                                                    ""
                                                  )}
                                                </td>
                                                <td>{item.TPIName}</td>
                                                <td>
                                                  {item.TPIContactPersonName}
                                                </td>
                                                <td
                                                  style={{
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  {item.displayTPIExpectedDate}
                                                </td>
                                              </tr>
                                            )
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan={4}
                                              style={{
                                                textAlign: "left",
                                              }}
                                            >
                                              <div>{"No Record Found..."}</div>
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="card mb-2" style={{ height: "auto" }}>
                      <div className="card-body p-2">
                        <Row>
                          <Col lg={6}>
                            <div className="mb-2">
                              <label className="mb-1">Test Master Images</label>
                              <div className="input-group">
                                <span className="form-control form-control-sm ps-2">
                                  <Link
                                    to="#"
                                    className="text-primary"
                                    onClick={() => {
                                      setShowTestMasterImagesModal(true);
                                    }}
                                  >
                                    View Test Master Images
                                  </Link>
                                </span>
                              </div>
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="mb-2">
                              <label className="mb-1">Testing Images</label>
                              <div className="input-group">
                                <span className="form-control form-control-sm ps-2">
                                  <Link
                                    to="#"
                                    className="text-primary"
                                    onClick={() => {
                                      setShowTestingImagesModal(true);
                                    }}
                                  >
                                    View Testing Images
                                  </Link>
                                </span>

                                <div
                                  className="input-group-text"
                                  title="Add Testing Images"
                                  style={{
                                    borderRadius: "0 0.375rem 0.375rem 0",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setShowTestingImagesModal(true);
                                  }}
                                >
                                  <i className="fa fa-plus" />
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr className="mt-0 mb-1"></hr>
            <Row>
              {/* <div className="d-flex justify-content-between mb-0">
                <div className="d-flex mb-0">
                  <label>Testing Parameters</label>
                </div>
              </div> */}
              <Col lg={12}>
                <div className="p-2 pt-0">
                  <div className="default-tab">
                    <Tab.Container defaultActiveKey={"detail"}>
                      <Nav as="ul" className="nav-tabs">
                        {ListOfForms?.length > 0
                          ? ListOfForms?.map((item, index) => (
                              <Nav.Item as="li" key={index}>
                                <Nav.Link
                                  eventKey={
                                    item?.FormNo == 1
                                      ? "detail"
                                      : item?.FormNo == 2
                                      ? "equipment"
                                      : item?.FormNo == 3
                                      ? "probe"
                                      : ""
                                  }
                                >
                                  {item?.FormNo == 1 ? (
                                    <i className="la la-comment me-2" />
                                  ) : item?.FormNo == 2 ? (
                                    <i className="la la-user-cog me-2"></i>
                                  ) : item?.FormNo == 3 ? (
                                    <i className="la la-cogs me-2"></i>
                                  ) : (
                                    ""
                                  )}
                                  {item?.label}
                                </Nav.Link>
                              </Nav.Item>
                            ))
                          : ""}
                      </Nav>
                      <Tab.Content className="pt-2">
                        {ListOfForms?.length > 0
                          ? ListOfForms?.map((item, index) => (
                              <Tab.Pane
                                eventKey={
                                  item?.FormNo == 1
                                    ? "detail"
                                    : item?.FormNo == 2
                                    ? "equipment"
                                    : item?.FormNo == 3
                                    ? "probe"
                                    : ""
                                }
                                key={index}
                              >
                                <div
                                  className="card mb-2"
                                  style={{ height: "auto" }}
                                >
                                  <div className="card-body p-2">
                                    <Row>
                                      <Col lg={12}>
                                        <div className="table-responsive active-projects style-1 shorting mb-2">
                                          <div
                                            id="ParameterDetail-tbl_wrapper"
                                            className="dataTables_wrapper table-responsive no-footer"
                                          >
                                            {index == 0 ? (
                                              <table
                                                id="ParameterDetail-tbl"
                                                className="table table-bordered no-footer mb-0"
                                              >
                                                <thead>
                                                  <tr>
                                                    <th width="2%"></th>
                                                    <th width="8%">Ch. No</th>
                                                    <th width="8%">Ch. Date</th>
                                                    <th width="8%">Offer No</th>
                                                    <th width="8%">
                                                      Offer Date
                                                    </th>
                                                    <th width="10%">
                                                      {JobDescripationLabel
                                                        ? JobDescripationLabel
                                                        : "Job Descripation"}
                                                    </th>
                                                    <th width="8%">
                                                      {UTNoLabel
                                                        ? UTNoLabel
                                                        : "Tested Area"}
                                                    </th>
                                                    <th width="8%">
                                                      {HeatNoLabel
                                                        ? HeatNoLabel
                                                        : "Size(mm)"}
                                                    </th>
                                                    <th width="8%">
                                                      {JointNoLabel
                                                        ? JointNoLabel
                                                        : "Joint No"}
                                                    </th>
                                                    <th width="8%">
                                                      {QtyLabel
                                                        ? QtyLabel
                                                        : "Quantity"}
                                                    </th>
                                                    <th width="8%">
                                                      Observation
                                                    </th>

                                                    <th
                                                      width="8%"
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      Result
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {ListOfTestingUTDetail?.length >
                                                  0 ? (
                                                    ListOfTestingUTDetail?.map(
                                                      (itemTest, indxTest) => (
                                                        <tr
                                                          key={indxTest}
                                                          style={{
                                                            display:
                                                              itemTest.IsDelete ==
                                                              true
                                                                ? "none"
                                                                : "",
                                                          }}
                                                        >
                                                          <td className="p-1">
                                                            <Link
                                                              to="#"
                                                              className="icon-box icon-box-md bg-primary-light"
                                                              title="New Testing Detail"
                                                              onClick={(e) => {
                                                                addTestingParameters(
                                                                  indxTest
                                                                );
                                                                e.preventDefault();
                                                              }}
                                                            >
                                                              <i className="fa fa-plus"></i>
                                                            </Link>
                                                            {ListOfTestingUTDetail?.filter(
                                                              (x) =>
                                                                x.IsDelete ==
                                                                false
                                                            )?.length > 1 ? (
                                                              <Link
                                                                to="#"
                                                                className="icon-box icon-box-md bg-danger-light ms-1"
                                                                title="Remove Testing Detail"
                                                                onClick={(
                                                                  e
                                                                ) => {
                                                                  removeTestingParameters(
                                                                    indxTest
                                                                  );
                                                                  e.preventDefault();
                                                                }}
                                                              >
                                                                <i className="fa fa-minus"></i>
                                                              </Link>
                                                            ) : (
                                                              ""
                                                            )}
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTDetail[${indxTest}].ChallanNo`}
                                                              placeholder={
                                                                "Ch No"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={500}
                                                              menuPosition="fixed"
                                                              //isClearable={false}
                                                            />
                                                          </td>

                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "105px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTDetail[${indxTest}].ChallanDate`}
                                                              placeholder={
                                                                "Select Ch Date"
                                                              }
                                                              component={
                                                                CustomFlatpickr
                                                              }
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              options={{
                                                                altInput: true,
                                                                altFormat:
                                                                  "j-M-Y",
                                                                dateFormat:
                                                                  "d-m-Y",
                                                                minDate:
                                                                  InwardDate
                                                                    ? new Date(
                                                                        InwardDate
                                                                      )
                                                                    : "",
                                                                maxDate:
                                                                  new Date(),
                                                              }}
                                                              onChange={(e) => {
                                                                formik.setFieldValue(
                                                                  `ListOfTestingUTDetail[${indxTest}].ChallanDate`,
                                                                  e
                                                                );
                                                              }}
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "105px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTDetail[${indxTest}].OfferNo`}
                                                              placeholder={
                                                                "Offer No"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "105px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTDetail[${indxTest}].OfferDate`}
                                                              placeholder={
                                                                "Select Offer Date"
                                                              }
                                                              component={
                                                                CustomFlatpickr
                                                              }
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              options={{
                                                                altInput: true,
                                                                altFormat:
                                                                  "j-M-Y",
                                                                dateFormat:
                                                                  "d-m-Y",
                                                                minDate:
                                                                  InwardDate
                                                                    ? new Date(
                                                                        InwardDate
                                                                      )
                                                                    : "",
                                                                maxDate:
                                                                  new Date(),
                                                              }}
                                                              onChange={(e) => {
                                                                formik.setFieldValue(
                                                                  `ListOfTestingUTDetail[${indxTest}].OfferDate`,
                                                                  e
                                                                );
                                                              }}
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "105px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTDetail[${indxTest}].JobDescripation`}
                                                              placeholder={
                                                                "Job Descripation"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "105px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTDetail[${indxTest}].UTNo`}
                                                              placeholder={
                                                                "Tested Area"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "105px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTDetail[${indxTest}].HeatNo`}
                                                              placeholder={
                                                                "Size"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "105px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTDetail[${indxTest}].JointNo`}
                                                              placeholder={
                                                                "Joint No"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "105px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTDetail[${indxTest}].Quantity`}
                                                              placeholder={
                                                                "Quantity"
                                                              }
                                                              type="number"
                                                              component={
                                                                CustomInput
                                                              }
                                                              maxLength={5}
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              numberTypeWithoutDot={
                                                                true
                                                              }
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "105px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTDetail[${indxTest}].Observation`}
                                                              placeholder={
                                                                "Observation"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={500}
                                                            />
                                                          </td>

                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              textAlign: "left",
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTDetail[${indxTest}].Result`}
                                                              placeholder={
                                                                "Result"
                                                              }
                                                              type="text"
                                                              component={
                                                                CustomInput
                                                              }
                                                              maxLength={500}
                                                              noMarginBottom={
                                                                true
                                                              }
                                                            />
                                                          </td>
                                                        </tr>
                                                      )
                                                    )
                                                  ) : (
                                                    <tr>
                                                      <td
                                                        colSpan={13}
                                                        style={{
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        <div>
                                                          {"No Record Found..."}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )}
                                                </tbody>
                                              </table>
                                            ) : index == 1 ? (
                                              <table
                                                id="EquipmentDetail-tbl"
                                                className="table table-bordered no-footer mb-0"
                                              >
                                                <thead>
                                                  <tr>
                                                    <th width="2%"></th>
                                                    <th width="20%">
                                                      Equipment
                                                    </th>
                                                    <th width="20%">Make</th>

                                                    <th width="15%">Sr. No</th>
                                                    <th
                                                      width="15%"
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      Cali. Dute Date
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {ListOfTestingUTEquipmentDetail?.length >
                                                  0 ? (
                                                    ListOfTestingUTEquipmentDetail?.map(
                                                      (itemTest, indxTest) => (
                                                        <tr
                                                          key={indxTest}
                                                          style={{
                                                            display:
                                                              itemTest.IsDelete ==
                                                              true
                                                                ? "none"
                                                                : "",
                                                          }}
                                                        >
                                                          <td className="p-1">
                                                            <Link
                                                              to="#"
                                                              className="icon-box icon-box-md bg-primary-light"
                                                              title="New Equipment"
                                                              onClick={(e) => {
                                                                addTestingParametersEquipment(
                                                                  indxTest
                                                                );
                                                                e.preventDefault();
                                                              }}
                                                            >
                                                              <i className="fa fa-plus"></i>
                                                            </Link>
                                                            {ListOfTestingUTEquipmentDetail?.filter(
                                                              (x) =>
                                                                x.IsDelete ==
                                                                false
                                                            )?.length > 1 ? (
                                                              <Link
                                                                to="#"
                                                                className="icon-box icon-box-md bg-danger-light ms-1"
                                                                title="Remove Equipment"
                                                                onClick={(
                                                                  e
                                                                ) => {
                                                                  removeTestingParametersEquipment(
                                                                    indxTest
                                                                  );
                                                                  e.preventDefault();
                                                                }}
                                                              >
                                                                <i className="fa fa-minus"></i>
                                                              </Link>
                                                            ) : (
                                                              ""
                                                            )}
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTEquipmentDetail[${indxTest}].EquipmentIDEncrypt`}
                                                              placeholder={
                                                                "Select Equipment"
                                                              }
                                                              component={
                                                                CustomSelect
                                                              }
                                                              options={
                                                                machineOptions
                                                              }
                                                              isClearable={
                                                                false
                                                              }
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={500}
                                                              menuPosition="fixed"
                                                              onChange={(e) => {
                                                                handleChangeEquipmentDetail(
                                                                  e,
                                                                  indxTest
                                                                );
                                                              }}
                                                              //isClearable={false}
                                                            />
                                                          </td>

                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "105px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTEquipmentDetail[${indxTest}].Make`}
                                                              placeholder={
                                                                "Make"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                              disabled={true}
                                                            />
                                                          </td>

                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "105px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTEquipmentDetail[${indxTest}].SerialNo`}
                                                              placeholder={
                                                                "Sr. No"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                              disabled={true}
                                                            />
                                                          </td>

                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              textAlign: "left",
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTEquipmentDetail[${indxTest}].CalibrationDueDate`}
                                                              placeholder={
                                                                "Cali Due Date"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                              disabled={true}
                                                            />
                                                          </td>
                                                        </tr>
                                                      )
                                                    )
                                                  ) : (
                                                    <tr>
                                                      <td
                                                        colSpan={13}
                                                        style={{
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        <div>
                                                          {"No Record Found..."}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )}
                                                </tbody>
                                              </table>
                                            ) : index == 2 ? (
                                              <table
                                                id="ProbeDetail-tbl"
                                                className="table table-bordered no-footer mb-0"
                                              >
                                                <thead>
                                                  <tr>
                                                    <th width="2%"></th>
                                                    <th width="15%">
                                                      Type Of Probe
                                                    </th>
                                                    <th width="10%">
                                                      Size Of Probe
                                                    </th>
                                                    <th width="13%">
                                                      Refraction Angle
                                                    </th>
                                                    <th width="13%">
                                                      Frequency
                                                    </th>
                                                    <th width="10%">Sr. No</th>
                                                    <th width="15%">Remark</th>
                                                    <th width="15%">
                                                      Ref. Gain
                                                    </th>
                                                    <th width="15%">
                                                      Scanning Gain
                                                    </th>
                                                    <th
                                                      width="15%"
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      Cali. Range
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {ListOfTestingUTProbDetail?.length >
                                                  0 ? (
                                                    ListOfTestingUTProbDetail?.map(
                                                      (itemTest, indxTest) => (
                                                        <tr
                                                          key={indxTest}
                                                          style={{
                                                            display:
                                                              itemTest.IsDelete ==
                                                              true
                                                                ? "none"
                                                                : "",
                                                          }}
                                                        >
                                                          <td className="p-1">
                                                            <Link
                                                              to="#"
                                                              className="icon-box icon-box-md bg-primary-light"
                                                              title="New Testing Detail"
                                                              onClick={(e) => {
                                                                addProbeDetail(
                                                                  indxTest
                                                                );
                                                                e.preventDefault();
                                                              }}
                                                            >
                                                              <i className="fa fa-plus"></i>
                                                            </Link>
                                                            {ListOfTestingUTProbDetail?.filter(
                                                              (x) =>
                                                                x.IsDelete ==
                                                                false
                                                            )?.length > 1 ? (
                                                              <Link
                                                                to="#"
                                                                className="icon-box icon-box-md bg-danger-light ms-1"
                                                                title="Remove Testing Detail"
                                                                onClick={(
                                                                  e
                                                                ) => {
                                                                  removeProbeDetail(
                                                                    indxTest
                                                                  );
                                                                  e.preventDefault();
                                                                }}
                                                              >
                                                                <i className="fa fa-minus"></i>
                                                              </Link>
                                                            ) : (
                                                              ""
                                                            )}
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTProbDetail[${indxTest}].TypeOfProbe`}
                                                              placeholder={
                                                                "Type Of Probe"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={500}
                                                              menuPosition="fixed"
                                                              //isClearable={false}
                                                            />
                                                          </td>

                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTProbDetail[${indxTest}].SizeOfProbe`}
                                                              placeholder={
                                                                "Size Of Probe"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={500}
                                                              menuPosition="fixed"
                                                              //isClearable={false}
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTProbDetail[${indxTest}].RefractionAngle`}
                                                              placeholder={
                                                                "Refraction Angle"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTProbDetail[${indxTest}].Frequency`}
                                                              placeholder={
                                                                "Frequency"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTProbDetail[${indxTest}].SerialNo`}
                                                              placeholder={
                                                                "Sr. No"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTProbDetail[${indxTest}].Remark`}
                                                              placeholder={
                                                                "Remark"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTProbDetail[${indxTest}].RefGain`}
                                                              placeholder={
                                                                "Ref. Gain"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                            />
                                                          </td>
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTProbDetail[${indxTest}].ScanningGain`}
                                                              placeholder={
                                                                "Scanning Gain"
                                                              }
                                                              component={
                                                                CustomInput
                                                              }
                                                              type="text"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={100}
                                                            />
                                                          </td>

                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              textAlign: "left",
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            <Field
                                                              name={`ListOfTestingUTProbDetail[${indxTest}].CalibrationRange`}
                                                              placeholder={
                                                                "Cali. Range"
                                                              }
                                                              type="text"
                                                              component={
                                                                CustomInput
                                                              }
                                                              maxLength={500}
                                                              noMarginBottom={
                                                                true
                                                              }
                                                            />
                                                          </td>
                                                        </tr>
                                                      )
                                                    )
                                                  ) : (
                                                    <tr>
                                                      <td
                                                        colSpan={13}
                                                        style={{
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        <div>
                                                          {"No Record Found..."}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )}
                                                </tbody>
                                              </table>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                  </div>
                                </div>
                              </Tab.Pane>
                            ))
                          : ""}
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                </div>
              </Col>
            </Row>
            <hr className="mt-0 mb-1"></hr>
            <Row>
              <Col lg={6}>
                <Field
                  label="Result"
                  name="Result"
                  placeholder={"Enter Result"}
                  component={CustomTextArea}
                  rows={5}
                  maxLength={2000}
                />
              </Col>
              <Col lg={6}>
                <Link
                  to="#"
                  className="icon-box icon-box-md bg-primary-light me-1"
                  title="Select Testing Remarks"
                  style={{ float: "right" }}
                  onClick={() => {
                    setShowTestingRemarksModal(true);
                  }}
                >
                  <i className="fa fa-edit"></i>
                </Link>
                <Field
                  label="Remarks"
                  name="Remarks"
                  placeholder={"Enter Remarks"}
                  component={CustomTextArea}
                  rows={5}
                  maxLength={2000}
                />
              </Col>
            </Row>
            {TestingStatus > 1 ? (
              <Row>
                <Col lg={6}>
                  <Field
                    label="Change Note"
                    name="ChangeNote"
                    placeholder={"Enter Change Note"}
                    component={CustomTextArea}
                    rows={5}
                    maxLength={2000}
                    required
                  />
                </Col>
              </Row>
            ) : (
              ""
            )}
            <div className="stickyBottomButtons">
              <hr className="mt-0 mb-2"></hr>
              {InwardMaterialTestDetailIDEncrypt && AllowTestingEdit == 1 && (
                <>
                  {TestingStatus <= 2 && (
                    <>
                      <button
                        type="submit"
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => {
                          formik.setFieldValue("btnSubmitType", 1);
                        }}
                      >
                        <i className="fa fa-bookmark"></i> Draft
                      </button>
                    </>
                  )}
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => {
                      formik.setFieldValue("btnSubmitType", 2);
                    }}
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  {AuthUser?.Permissions?.IsOperationApprover == true &&
                    AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                    AuthUser?.Permissions?.TestingApprovalRequired == true && (
                      <button
                        type="submit"
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => {
                          formik.setFieldValue("btnSubmitType", 3);
                        }}
                      >
                        <i className="fa-solid fa-floppy-disk"></i> Submit &
                        Approve
                      </button>
                    )}
                </>
              )}
              <button
                type="button"
                className="btn btn-danger btn-sm"
                onClick={(e) => {
                  if (
                    AuthUser?.Permissions?.TestingAfterSaveStayOnEntryScreen ==
                    true
                  ) {
                    navigate("/testing-list");
                  } else {
                    navigate(-1);
                  }
                }}
              >
                <i className="fa fa-cancel"></i> Cancel
              </button>
            </div>
          </Form>
        </FormikProvider>
      </div>

      <Modal
        className="fade"
        show={showAddTPIDetailModal}
        onHide={setShowAddTPIDetailModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikTPIDetail}>
            <Form onSubmit={formikTPIDetail.handleSubmit}>
              <Modal.Header>
                <Modal.Title>
                  {actionFlagTPI == 1 ? "Edit" : "Add"} TPI Detail
                </Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowAddTPIDetailModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <Field
                      label="TPI"
                      name="TPIIDEncrypted"
                      placeholder={"Select TPI"}
                      options={MainFormik?.tpiCustomerOptions}
                      component={CustomSelect}
                      required
                      onChange={(e) => {
                        formikTPIDetail.setFieldValue(
                          "TPIIDEncrypted",
                          e.value ?? ""
                        );
                        formikTPIDetail.setFieldValue("TPIName", e.label ?? "");
                      }}
                    />
                  </Col>
                  <Col lg={12}>
                    <Field
                      label="TPI Contact Person"
                      name="TPIContactPersonIDEncrypted"
                      placeholder={"Select Contact Person"}
                      options={tpiContactPersonOptions}
                      component={CustomSelect}
                      required
                      onChange={(e) => {
                        formikTPIDetail.setFieldValue(
                          "TPIContactPersonIDEncrypted",
                          e.value ?? ""
                        );
                        formikTPIDetail.setFieldValue(
                          "TPIContactPersonName",
                          e.label ?? ""
                        );
                      }}
                    />
                  </Col>
                  <Col lg={12}>
                    <Field
                      label="TPI Expected Date"
                      name="TPIExpectedDate"
                      placeholder={"Select Expected Date"}
                      component={CustomFlatpickr}
                      options={{
                        altInput: true,
                        altFormat: "j-M-Y",
                        dateFormat: "d-m-Y",
                        minDate: InwardDate ? new Date(InwardDate) : new Date(),
                        static: true, //to solve month dropdown not visible inside modal
                      }}
                    />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary btn-sm" type="submit">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </Button>
                <Button
                  variant="danger btn-sm"
                  onClick={() => setShowAddTPIDetailModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showTestMasterImagesModal}
        onHide={setShowTestMasterImagesModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Test Master Images</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowTestMasterImagesModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive active-projects style-1 shorting mb-2">
              <div
                id="TestMasterImages-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="TestMasterImages-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="2%"></th>
                      <th width="98%" style={{ textAlign: "left" }}>
                        Image Preview
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {ListTestMasterImages?.length > 0 ? (
                      ListTestMasterImages?.map((item, indx) => (
                        <tr key={indx}>
                          <td>
                            <Link
                              to="#"
                              className="icon-box icon-box-md me-1"
                              title="View"
                              onClick={() => {
                                window.open(item.ImageFilePath, "_blank");
                              }}
                            >
                              <i className="fa fa-eye"></i>
                            </Link>
                          </td>
                          <td>
                            <div
                              className="image-placeholder"
                              style={{
                                maxWidth: "100px",
                                margin: "10px",
                                zIndex: 0,
                              }}
                            >
                              <div
                                className="avatar-preview"
                                style={{
                                  width: "100px",
                                  height: "auto",
                                }}
                              >
                                <div id="testMasterImagePreview">
                                  <img
                                    id="saveTestMasterImageFile"
                                    src={item.ImageFilePath}
                                    alt={"Image"}
                                    onClick={() => {
                                      window.open(item.ImageFilePath, "_blank");
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showTestingImagesModal}
        onHide={setShowTestingImagesModal}
        size="lg"
      >
        <FormikProvider value={formikTestingImages}>
          <Form onSubmit={formikTestingImages.handleSubmit}>
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <Modal.Header>
                <Modal.Title>Testing Images</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowTestingImagesModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <div style={{ float: "right", marginRight: "2rem" }}>
                      + Add
                      <div
                        className="open-file mt-2"
                        style={{ marginLeft: "2rem" }}
                      >
                        <input
                          type="file"
                          id="TestingImages"
                          accept="image/png, image/gif, image/jpeg"
                          onChange={uploadTestingResultImage}
                        />
                        <label htmlFor="TestingImages" name=""></label>
                      </div>
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="TestingImages-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="TestingImages-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="4%"></th>
                              <th width="50%">Image Preview</th>
                              <th width="46%" style={{ textAlign: "left" }}>
                                Remarks
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ListTestingResultImages?.filter(
                              (x) => x.IsDeleted == false
                            ).length > 0 ? (
                              ListTestingResultImages?.map((item, indx) => (
                                <tr
                                  key={indx}
                                  style={{
                                    display:
                                      item?.IsDeleted == true ? "none" : "",
                                  }}
                                >
                                  <td>
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="View"
                                      onClick={() => {
                                        window.open(
                                          item.ResultImagePath
                                            ? item.ResultImagePath
                                            : item.viewFile,
                                          "_blank"
                                        );
                                      }}
                                    >
                                      <i className="fa fa-eye"></i>
                                    </Link>

                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        delete_RecordWithoutApi(
                                          deleteTestingResultImage,
                                          indx
                                        );
                                      }}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                  </td>
                                  <td>
                                    <div
                                      className="image-placeholder"
                                      style={{
                                        maxWidth: "100px",
                                        margin: "10px",
                                        zIndex: 0,
                                      }}
                                    >
                                      <div
                                        className="avatar-preview"
                                        style={{
                                          width: "100px",
                                          height: "auto",
                                        }}
                                      >
                                        <div id="testingImagePreview">
                                          <img
                                            id="saveTestMasterImageFile"
                                            src={
                                              item.ResultImagePath
                                                ? item.ResultImagePath
                                                : item.viewFile
                                            }
                                            alt={"Image"}
                                            onClick={() => {
                                              window.open(
                                                item.ResultImagePath
                                                  ? item.ResultImagePath
                                                  : item.viewFile,
                                                "_blank"
                                              );
                                            }}
                                            style={{ cursor: "pointer" }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <Field
                                      name={`ListTestingResultImages[${indx}].Remarks`}
                                      component={CustomInput}
                                      value={
                                        ListTestingResultImages[indx]
                                          ?.Remarks || ""
                                      }
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `ListTestingResultImages[${indx}].Remarks`,
                                          e?.target?.value ?? ""
                                        );
                                      }}
                                    />
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={3} style={{ textAlign: "left" }}>
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
            </Spin>
          </Form>
        </FormikProvider>
      </Modal>

      <Modal
        className="fade"
        show={showTestingRemarksModal}
        onHide={setShowTestingRemarksModal}
        size="lg"
      >
        <FormikProvider value={formikTestingRemarks}>
          <Form onSubmit={formikTestingRemarks.handleSubmit}>
            <Modal.Header>
              <Modal.Title>Testing Remarks</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowTestingRemarksModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="table-responsive active-projects style-1 shorting mb-0">
                    <div
                      id="TestingRemarks-tbl_wrapper"
                      className="dataTables_wrapper table-responsive no-footer"
                    >
                      <table
                        id="TestingRemarks-tbl"
                        className="table table-bordered no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="5%"></th>
                            <th width="95%" style={{ textAlign: "left" }}>
                              Testing Remarks
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {TestingRemarksList?.length > 0 ? (
                            TestingRemarksList?.map((item, indx) => (
                              <tr key={indx}>
                                <td
                                  style={{
                                    textAlign: "center",
                                    padding: "0.5rem",
                                    width: "5%",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`chkTestingRemarks${indx}`}
                                    name={`chkTestingRemarks${indx}`}
                                    checked={item.IsSelected}
                                    onChange={(e) => {
                                      formikTestingRemarks.setFieldValue(
                                        "TestingRemarksList",
                                        TestingRemarksList?.map((x, idx) => {
                                          if (idx == indx) {
                                            return {
                                              ...x,
                                              IsSelected: true,
                                            };
                                          } else {
                                            return {
                                              ...x,
                                              IsSelected: false,
                                            };
                                          }
                                        })
                                      );
                                    }}
                                  />
                                </td>
                                <td
                                  style={{
                                    textAlign: "left",
                                    padding: "0.5rem",
                                    width: "95%",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {item.TestingRemarks}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No record found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit" variant="primary btn-sm">
                <i className="fa-solid fa-plus"></i> Add
              </Button>

              <Button
                variant="danger btn-sm"
                onClick={() => {
                  setShowTestingRemarksModal(false);
                }}
              >
                <i className="fa fa-cancel"></i> Cancel
              </Button>
            </Modal.Footer>
          </Form>
        </FormikProvider>
      </Modal>

      <Modal
        className="fade"
        show={showDefineMoreRatesModal}
        onHide={setShowDefineMoreRatesModal}
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikDefineMoreRates}>
            <Form onSubmit={formikDefineMoreRates.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Define More Rates</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowDefineMoreRatesModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="DefineMoreRates-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="DefineMoreRates-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="5%" className="ps-1"></th>
                              <th width="95%" style={{ textAlign: "left" }}>
                                Rate Type
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {MoreTestRatesList?.length > 0 ? (
                              MoreTestRatesList?.map((itemTest, indxTest) => (
                                <tr key={indxTest}>
                                  <td className="p-1">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkIsSelected${indxTest}`}
                                      name={`chkIsSelected${indxTest}`}
                                      checked={itemTest?.IsSelected}
                                      onChange={(e) => {
                                        formikDefineMoreRates.setFieldValue(
                                          `MoreTestRatesList[${indxTest}].IsSelected`,
                                          e?.target?.checked
                                        );
                                      }}
                                    />
                                  </td>

                                  <td style={{ textAlign: "left" }}>
                                    {itemTest?.RateTypeName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={10} style={{ textAlign: "left" }}>
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                {IsReTestTesting === false ? (
                  <Button type="submit" variant="primary btn-sm">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                ) : (
                  ""
                )}
                <Button
                  variant="danger btn-sm"
                  onClick={() => setShowDefineMoreRatesModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
    </>
  );
};

export default NDTProcessTypeUT;
